import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Query, QueryList, ViewChildren } from '@angular/core';
import { ScheduleService } from '../schedule.service';
import { ScheduleJob } from '../schedulejob';
import { STEVES_EMPLOYEES, JOHN_BRILEY_EMPLOYEES, MANDATORY_JOB_TAG_ID, OOW_REGIONS } from 'src/app/utils/constants';
import { isSchedulingUser } from 'src/app/utils/helpers';
import { EMPTY, Observable, Subject, Subscription, forkJoin, of } from 'rxjs';
import { tap, map, switchMap, takeUntil, catchError } from 'rxjs/operators';
import { MatDialogModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RatingPhotosDialogComponent } from '../rating-photos/ratingphotos.component';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { RaterformComponent, RaterformSelectorComponent } from '../../raterform/raterform/raterform.component';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { EditJobDialogComponent } from '../../location/location.component';
import { StartDayWarningDialogComponent, ScheduledJobsWarningDialogComponent, TimeCardDialogComponent } from './timecard-dialog.component';
import { LoggingService } from '../../utils/logging.service';
import { io } from 'socket.io-client';
import { AuthService } from '../../auth.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { LocationService } from '../../location/location.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { EditSubdivisionDialogComponent } from '../../subdivisions/subdivisions/subdivisions.component';
import { SubdivisionService } from '../../subdivisions/subdivision.service';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MatCalendarCellCssClasses } from '@angular/material';
import { BatchEditComponent } from './batchEdit.component';
import { FailReasonComponent } from './failreason.component';
import { AdditionalworkComponent } from '../../additionalwork/additionalwork.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
//import { time } from 'console';
import * as moment from 'moment-timezone';
import { EmployeeService } from 'src/app/employee/employee.service';
import { TrainingService } from 'src/app/training/training.service';
import { OnOurWayLogService } from '../../onourwaylog/onourwaylog.service';
import { TrainingRequestModalComponent, TrainingRequestModalData } from 'src/app/training/training-request-modal/training-request-modal.component';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { WarningPopupComponent } from '../../utils/warning-popup/warning-popup.component';
import { SelfiePromptComponent } from '../selfie-prompt/selfie-prompt.component';
import { deriveScheduleView, isQIJob as isQIJobFn, isEnergyJob as isEnergyJobFn, filterByJobType, filterByRegion } from '../schedule-view';
enum EMAILTYPE {
  Custom = 1,
  Prod = 2,
  MFConsultant = 4
}

enum SCHEDTYPE {
  Normal = 1,
  Office = 2
}




@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit, AfterViewInit {

  // getJobs = jobListService.getJobs;
  job$: Observable<ScheduleJob[]>;
  faedit = faEdit;
  faEko = faLeaf;
  fagoogle = faGoogle;  
  fahardhat = faHardHat;
  public socket: any;
  firstJobDone: boolean;
  filterActivated: boolean;
  loadingScroll: boolean;
  lastPageLoaded: boolean;
  backspacePressed: boolean = false;
  isPaused: boolean = false;
  isClockedIn: boolean = false;
  private clockedInSubscription: Subscription;

  

  areTimeButtonsDisabled: boolean = false;

  @ViewChildren('checkbox') checkboxes: QueryList<HTMLInputElement>;
  role: any;
  batchEditing: boolean = false;
  filterBySiteVisit: boolean = false;
  viewingPhotos: boolean = true;
  modalJob: any;
  modalSub: any;
  jobtypeFilterType: string = '' ;
  regionFilterActive: boolean = false;
  currentexportID: any;
;

  constructor(  private breakpointobserver: BreakpointObserver, private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, public scheduleService: ScheduleService, public subService: SubdivisionService, public dialog: MatDialog, public logger: LoggingService, public messager: MessagerComponent, public employeeService: EmployeeService, public auth: AuthService, public ges: GlobalEmailService, public locationService: LocationService, public router: Router, private trainingService: TrainingService, private oowLog: OnOurWayLogService) { }


  ngAfterViewInit(): void {

    this.lastItem.changes.subscribe( (res) => {
      if(res.last){
        this.lastContentObserver.observe(res.last.nativeElement);
      }
    })
  }


  @ViewChildren('lastItem',{read: ElementRef})
  lastItem:QueryList<ElementRef>


  scheduleDate = '';
  sd : Date | null;
  toggleLink: boolean;
  toggleItem: any[] = [];
  openFullDetails: boolean = false;
  employeeFilter: string;
  allFilter: string;
  isLoading: boolean;
  // Full day's list still fetching; the totals header shows a spinner
  allJobsLoading = false;
  jobsText = '';
  jobsToday: any[] = [];
  // Cards whose dropdowns have been turned into real mat-selects (key: job_id:kind)
  lazySelects = new Set<string>();
  regions: any[] = [];
  selectedRegion: string[] = [];
  theNumber = 0;
  //flexjobs: [];
  title;
  version;
  initialAllLoaded: boolean = false;
  totalJobPages: number;
  currentPage: number = 0;
  siteVisitJobs:[];
  allTheJobs: any[] = [];
  editJobIds: any[] = [];
  // Subset of editJobIds carrying the 'Mandatory Job' tag. Collected at selection
  // time because the batch dialog is handed job ids only, with no tag data.
  mandatoryJobIds: any[] = [];
  isScheduler: boolean = false;
  employeetype: string = '';

  emailSentStatus: { [jobId: number]: boolean } = {};
  oowPressedStatus: { [jobId: number]: boolean } = {};  // On Our Way pressed for this job (persisted via audit log)

  user;
  usernamee;
  employeeID;

  class = 'hidden'; // card class
  selectedJob;
  flexmode = false;
  lastContentObserver : any;
  loadFullList = false;
  filterjobtypeactive = false;
  hoursArray: any[] = [];
  failreasons : [];
  daystarted = false;
  doneLoading;
  displayStyle = 'display: block';
  year = new Date().getFullYear();
  holidays = []
  officeJobs =false;
  isToggleOn: boolean = false;
  scheduledOnly = false;  // "Scheduled only" switch; persists across date changes like the region/jobtype filters
  destroy$ = new Subject<void>();
  // Which date allTheJobs / pagedJobs belong to; renderJobs() blanks the list until they match scheduleDate
  allTheJobsDate = '';
  pagedJobs: any[] = [];
  pagedJobsDate = '';
  dayListPending = false;

  stati = [
    {value: 'Complete', viewValue: 'Complete'}, //green
    {value: 'EPO hold', viewValue: 'EPO hold'}, //red
    {value: 'Fail', viewValue: 'Fail'},//red
    {value: 'Fail-NR', viewValue: 'Fail-No Reschedule'},//red
    {value: 'On hold', viewValue: 'On hold'},//red
    {value: 'Pass', viewValue: 'Pass'}, //green
    {value: 'Scheduled', viewValue: 'Scheduled'},// neutral
    {value: 'UnderRev', viewValue: 'Under Review'},//green
    {value: 'Canceled', viewValue: 'Canceled'}//green
  ];
  
  reportStati = [
    {value: 'EngStamp', viewValue: 'Engineer Stamp'},//green
    {value: 'Complete', viewValue: 'Complete'},//green
    {value: 'PendInfo', viewValue: 'Pending Info'},//green
    {value: 'PendPaym', viewValue: 'Pending Payment'},//green
    {value: 'Rea4Review', viewValue: 'Ready for Review'},//green
    {value: 'Scheduled', viewValue: 'Scheduled'},//neutral
  ];



  ngOnInit(): void {



    this.activatedRoute.data.subscribe(
      data => {
        this.title = data.title;
        this.version = data.version;
        this.scheduleDate = this.scheduleService.getTodayFormatted();

        // Whole day's list for the picked date. Anything tagged with another date is stale.
        this.scheduleService.allJob$.pipe(takeUntil(this.destroy$)).subscribe(msg => {
          if (!msg || msg.date !== this.scheduleDate) { return; }
          this.allTheJobs = this.normalizeJobs(msg.jobs);
          this.allTheJobsDate = msg.date;
          this.renderJobs();
        });

        // First page for the picked date (or the whole list for a User role).
        this.scheduleService.gridObject$.pipe(takeUntil(this.destroy$)).subscribe(msg => {
          if (!msg || msg.date !== this.scheduleDate) { return; }
          this.pagedJobs = this.normalizeJobs(msg.jobs);
          this.pagedJobsDate = msg.date;
          this.renderJobs();
        });


        if(this.version == SCHEDTYPE.Normal){
          this.scheduleService.getAllRegions().subscribe(
            (res) => {
              this.regions = res.regions;
              this.regions.sort((a, b) => a.region_name.localeCompare(b.region_name));
            }, (err) => {
              this.logger.error('Error loading regions: ' + err);
              this.messager.openSnackBar('Error loading regions', '', 'errorAlert');
            }
          )
        }

        this.auth.employeetype$.subscribe(type => {
          this.employeetype = type;
          //remove canceled option for field inspectors
          if(this.employeetype.toLowerCase().includes('field')){
            this.stati = this.stati.filter(item => item.value != 'Canceled');
          }

          if(this.auth.getEmployeeName().includes('greenproserv')){
            this.reportStati= this.reportStati.filter(item => !item.value.includes('Complete'));
          }
        }); 

        this.scheduleService.init(this.version);
        this.startFunction();

          }
    )


  }
  
  compareConfStatus(a: string, b: string): boolean {
    if (b === 'Reschedule') return false;
    return a === b;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Trim statuses and refresh the email-sent map; the lists hold these same objects.
  private normalizeJobs(jobs: any[]): any[] {
    return (jobs || []).map(job => {
      if (typeof job.job_status === 'string') { job.job_status = job.job_status.trim(); }
      this.emailSentStatus[job.job_id] = !!job.email_sent;
      this.oowPressedStatus[job.job_id] = !!job.oow_pressed;
      return job;
    });
  }

  // The only writer of jobsToday / hoursArray. Call after any state change.
  renderJobs(): void {
    const view = deriveScheduleView({
      scheduleDate: this.scheduleDate,
      dayJobs: this.allTheJobs,
      dayJobsDate: this.allTheJobsDate,
      pagedJobs: this.pagedJobs,
      pagedJobsDate: this.pagedJobsDate,
      employeeFilter: this.employeeFilter,
      selectedRegion: this.selectedRegion,
      regionFilterActive: this.regionFilterActive,
      jobtypeFilterType: this.jobtypeFilterType,
      filterjobtypeactive: this.filterjobtypeactive,
      filterBySiteVisit: this.filterBySiteVisit,
      scheduledOnly: this.scheduledOnly,
      loadFullList: this.loadFullList,
      initialAllLoaded: this.initialAllLoaded,
      version: this.version,
      role: this.role,
      employeeID: this.employeeID,
    });
    this.jobsToday = view.jobs;
    this.hoursArray = view.hoursJobs;
    this.filterActivated = view.filterActivated;
    this.dayListPending = view.pending;
    this.updateHours(this.hoursArray);
    this.cdr.detectChanges();
  }

  startFunction(): void {

    this.filterActivated = false;
    this.loadingScroll = false;
    this.lastPageLoaded = false;

    this.clockedInSubscription = this.scheduleService.getIsClockedIn().subscribe(
      (res) => {
        this.isClockedIn = res;
      }
    );


    if(!this.scheduleDate){
      this.scheduleDate = this.scheduleService.getTodayFormatted();
    }

    this.scheduleService.getDayStarted().subscribe(
      res => {
        this.daystarted = res;
        this.scheduleService.getFirstJob().subscribe(
          res => {
            this.firstJobDone = res;
            this.doneLoading = true;
          }, err => {
            this.doneLoading = true;
          }
        )

        this.scheduleService.getIsPaused().subscribe(
          res => {
            this.isPaused = res;
          }, err => {
            this.isPaused = false;
          }
        )

        this.scheduleService.getIsClockedIn().subscribe(
          res => {
            this.isClockedIn = res;
          }, err => {
            this.isClockedIn = false;
          }
        );

      }, err => {
        this.doneLoading = true;
      }
    );

    this.intersectionObserver();
    this.getHolidays()

    this.scheduleService.loadingD$.subscribe(
      res => {
        this.isLoading = res;
      }
    );

    this.scheduleService.loadingAll$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.allJobsLoading = res;
      }
    );

    this.scheduleService.page$.subscribe(
      res => {
        this.totalJobPages = res;
      }
    )

    this.scheduleService.loadAllActivated$.subscribe(
      res =>{
        this.initialAllLoaded = res;
        if(this.version == SCHEDTYPE.Office){
          this.initialAllLoaded = true;
        }
      }
    )

    if(this.initialAllLoaded){
      this.hoursArray = [...this.allTheJobs]
    }else{
      this.hoursArray = [...this.jobsToday];
    }
    
    if(this.role == 'User'){
      this.hoursArray = this.hoursArray.filter(item => item.employee_id == this.employeeID);
    }

    this.updateHours(this.hoursArray);
    



    //this.scheduleService.allJob$.subscribe(
      //res => {
        //this.allTheJobs = res;
        //if(this.initialAllLoaded){
          //this.hoursArray = res;
        //}else {
          //this.hoursArray = [...this.jobsToday]
        //}

        //if(this.role == 'User'){
          //this.hoursArray = this.hoursArray.filter(item => item.employee_id == this.employeeID);
        //}
          //console.log('All jobs', this.updateHours(this.hoursArray));
      //}
    //)


    this.doneLoading = false;
    this.auth.userProfile$.subscribe(
      (profile) => {
        // userProfile$ is a BehaviorSubject seeded with null, so on a fresh load of
        // /schedule it emits null before Auth0 resolves. Reading off null here used
        // to throw, which makes RxJS drop this subscription -- isScheduler then
        // stayed false and Batch Edit refused to move Mandatory Jobs for schedulers.
        if(!profile){ return; }
        this.user = profile;
        this.role = profile['https://rhv2.com.role'];
        this.employeeID = this.auth.getEmployeeId();
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
        this.isScheduler = isSchedulingUser(profile);
        this.loadActiveEnrollment();
        this.renderJobs();
      });

      this.scheduleService.getTodaysSiteVisitJobsAll().subscribe(
        (res) => {
          this.siteVisitJobs = res.Jobs;
        },
        (err) => {
        }
      );

    this.scheduleService.getFailReasons().subscribe(
      res => {
        this.failreasons = res.Reasons;
      }, err => {
      });

  }


  /** Active training enrollment for the logged-in employee (shown in schedule banner). */
  activeEnrollment: any = null;

  loadActiveEnrollment(): void {
    if (!this.employeeID) {
      this.activeEnrollment = null;
      return;
    }
    this.trainingService.getEnrollments(this.employeeID).subscribe(
      (res) => {
        if (!res.Error && res.Enrollments && res.Enrollments.length) {
          const active = res.Enrollments.find((e: any) => e.status === 'ACTIVE');
          this.activeEnrollment = active || null;
        } else {
          this.activeEnrollment = null;
        }
      },
      () => { this.activeEnrollment = null; }
    );
  }



  expand(job) {
    this.selectedJob = job;
    this.class = 'fulldiv';
    //alert('Clicked!');
  }

  close() {
    this.class = 'hidden';
  }

  getStatusColor(status: string) {

    switch (status.trim()) {
      case 'Pass':
        return 'limegreen';
      case 'Fail':
        return 'red';
      case 'Complete':
        return 'limegreen';
      default:
        return '';
    }

  }

  getHolidays(){
    this.scheduleService.getHolidays(this.year).subscribe(
      res => {
       this.holidays = res?.Holidays || []
       this.holidays.push('2024-12-26');
       this.holidays.push('2024-11-29');
       this.holidays.push('2024-07-05');
      },
      err => {
      }
    )
  }


  isQIJob(job): boolean {
    return isQIJobFn(job);
  }


  isEnergyJob(job): boolean {
    return isEnergyJobFn(job);
  }


  onRegionChange(inputarray): any[]{
    return filterByRegion(this.selectedRegion, inputarray);
  }

  setFilterJobType(type: string) {
    this.jobtypeFilterType = type;
    this.filterjobtypeactive = true;
  }

  setRegionFilterActive() {
    this.regionFilterActive = this.selectedRegion.length > 0;
  }

  resetRegionFilter() {
    this.selectedRegion = [];
    this.regionFilterActive = false;
    this.processFilters()
  }

  resetJobTypeFilter() {
    this.jobtypeFilterType = '';
    this.filterjobtypeactive = false;
    this.processFilters();
  }

  filterJobType(type: string, inputarray): any[] {
    return filterByJobType(type, inputarray);
  }

  processFilters() {
    this.renderJobs();

  }

  showOfficeJobs() {
    this.jobsToday = this.siteVisitJobs;
    this.flexmode = false;
  }

  intersectionObserver() {

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3,
    };

    this.lastContentObserver = new IntersectionObserver( (entries)=> {

      //  debugger;
      this.loadingScroll = true;
      if(!this.filterActivated && this.initialAllLoaded && !this.loadFullList){
        if(entries[0].isIntersecting){

          if(this.currentPage < this.totalJobPages){
            this.currentPage++;
            const forDate = this.scheduleDate;
            const page$ = this.officeJobs
              ? this.scheduleService.getJobsByDateAndSiteVisit(forDate, this.currentPage)
              : this.scheduleService.getJobsByDate(forDate, this.currentPage);

            page$.subscribe(
              (res) => {
                // The user may have picked another date while this page was in flight.
                if (forDate !== this.scheduleDate || this.pagedJobsDate !== forDate) { return; }
                this.pagedJobs = this.pagedJobs.concat(this.normalizeJobs(res.Jobs));
                this.renderJobs();
              }, err => {
              }
            );

          }else {
            this.lastPageLoaded = true;
          }
        }
    }
    }, options)

    this.loadingScroll = false;

  }


  openEditJob(job, index) {

    let thisLocation = {
      city: job.city,
      location_id: job.location_id,
      lot: job.lot,
      plan_name: job.plan_name,
      plan: job.plan,
      state: job.state,
      street_address: job.street_address,
      subdivision: job.subdivision,
      subdivision_name: job.subdivision_name,
      zip: job.zip
    }

    let thisJob = {
      mode: 1,
      job: job,
      location: thisLocation,
      fetchedJob : {},
      fromPage : 'Schedule',
      usernamee : this.usernamee,
      enableTripFieldCascade: true,
    }

    this.scheduleService.getOneJob(job.job_id).subscribe(
      (res) => {

        thisJob.job = res.Job;
        thisJob.fetchedJob = res.Job;
        const dialogRef = this.dialog.open(EditJobDialogComponent, {
          width: '100vw',
          height: '100vh',
          data: thisJob,
          panelClass: ''
        }).afterClosed().subscribe(
          res => {
            if (!res || !res.job) { return; }
            const moved = job.schedule_date != res.job.schedule_date;
            job.technitian = res.job.technitian;
            job.employee_name = res.job.employee_name;
            job.phone = res.job.phone;
            job.e_mail = res.job.e_mail;
            job.contact_e_mail = (res.job.contact_e_mail || '').trim();
            job.contact_name = res.job.id;
            job.schedule_date = res.job.schedule_date;
            job.job_notes = res.job.job_notes;
            if (job.istrip) { job.trip_task_notes = res.job.trip_task_notes; }

            // Moved to another day: drop it from both source lists so a re-render cannot bring it back.
            if (moved) {
              this.pagedJobs = this.pagedJobs.filter(j => j.job_id !== job.job_id);
              this.allTheJobs = this.allTheJobs.filter(j => j.job_id !== job.job_id);
            }
            this.renderJobs();
          }
        );
      }, err => {
        this.messager.openSnackBar('There was an error loading this job:  ' + err.Message, '', 'errorAlert');
      })

  }

  dateClass() {
    return (date: Date): MatCalendarCellCssClasses => {
      const d2 = new Date(date)
      if(d2.getFullYear()!==this.year){
        this.year = d2.getFullYear()
        this.getHolidays()
      }
      const highlightDate = this.holidays?.map(strDate => new Date(strDate))
      .some(d => d.getDate() + 1 === d2.getDate() && d.getMonth() === d2.getMonth() && d.getFullYear() === d2.getFullYear());
      return highlightDate ? 'holiday-date' : '';
    };
  }

  pauseDay() {

    //update last clockout to current time
    let did;
    this.areTimeButtonsDisabled = true;
    this.messager.openSnackBar('Pausing day... ', '', 'successAlert');

    //getTodaysInfo (get the DID)
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.scheduleService.getDayInfo(this.employeeID, timezone).subscribe(
      res => {
        did = res.Data.did;
        //update last clockout here
        this.scheduleService.updateLastClockout(did, timezone).subscribe(
          res => {
            this.scheduleService.updatePaused(did).subscribe(
              res => {
                this.isPaused = res.ispaused.ispaused;
                this.areTimeButtonsDisabled = false;
                this.messager.openSnackBar('Day paused. ', '', 'successAlert');
              }, err => {
                this.areTimeButtonsDisabled = false;
                this.messager.openSnackBar('Error pausing', '', 'errorAlert')
              }
            )
          }, err => {
            this.areTimeButtonsDisabled = false;
            this.messager.openSnackBar('Error pausing day: ' + err, '', 'errorAlert');
          }
        )
      }, err => {
        this.areTimeButtonsDisabled = false;
        this.messager.openSnackBar('Error pausing day: ' + err, '', 'errorAlert');
        return;
      }
    )

  }


  resumeDay() {

    //update last clockout to current time
    //update last clockout to current time
    let did;
    this.areTimeButtonsDisabled = true;
    this.messager.openSnackBar('Resuming day... ', '', 'successAlert');

    //getTodaysInfo (get the DID)
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.scheduleService.getDayInfo(this.employeeID, timezone).subscribe(
      res => {
        did = res.Data.did;
        //update Total Pause time here
        //update last clockout here
        this.scheduleService.updateLastClockOutAndPauseTime(did, timezone).subscribe(
          res => {
            this.scheduleService.updatePaused(did).subscribe(
              res => {
                this.isPaused = res.ispaused.ispaused;
                this.areTimeButtonsDisabled = false;
                this.messager.openSnackBar('Day resumed. ', '', 'successString');
              }, err => {
                this.areTimeButtonsDisabled = false;
                this.messager.openSnackBar('Error resuming day', '', 'errorAlert')
              }
            )
          }, err => {
            this.areTimeButtonsDisabled = false;
            this.messager.openSnackBar('Error resuming day: ' + err, '', 'errorString');
          }
        )



      }, err => {
        this.areTimeButtonsDisabled = false;
        this.messager.openSnackBar('Error pausing day: ' + err, '', 'errorString');
        return;
      }
    )




  }




  onSelectDate(date: Date) {

    this.currentPage = 0;
    this.lastPageLoaded = false;
    this.loadingScroll = false;
    this.filterBySiteVisit = false;
    this.isToggleOn = false;
    this.flexmode = false;

    // Name / region / jobtype filters are kept and re-applied to the new day by renderJobs().
    this.scheduleDate = this.dateAsString(date);
    this.pagedJobs = [];
    this.pagedJobsDate = '';

    this.scheduleService.setInitialLoaded(true);
    this.scheduleService.dateChange(this.scheduleDate, this.loadFullList, this.version);

    this.isLoading = true;
    this.renderJobs();
  }

  handlejobloaderror(err) {
    this.logger.error('Error loading jobs: ' + err);
    this.messager.openSnackBar('Error loading jobs', '', 'errorAlert');
  }

  exportList() {
    let exportList = [];
    if(this.regionFilterActive || this.filterjobtypeactive || this.scheduledOnly){
      exportList = [...this.jobsToday];
    }else{
      exportList = [...this.allTheJobs];
    }

    //sort array by employee_name property of each item
    exportList.sort((a, b) => {
      if (a.employee_name < b.employee_name) {
        return -1;
      }
      if (a.employee_name > b.employee_name) {
        return 1;
      }
      return 0;
    });


    exportList = exportList.filter(job => job.sitevisitrqd === true);

    this.messager.openSnackBar('Opening jobs in new window....', '', 'successAlert', 5000);
    this.scheduleService.saveExportToDB(exportList).subscribe(
      res => {
        this.logger.info('Schedule Region Export used by ' + this.usernamee + ' with ID: ' + res.id  + ' at ' + new Date().toLocaleString());
        this.currentexportID = res.id;
        window.open(`/m/jobexports/${res.id}`, '_blank');
      }
    );

  }

  updateHours(array) {

    // Trip children (trip_id set) already have their time rolled up into their trip parent's
    // own estimatedtime (see recomputeTripEstimatedTime()) — counting them separately here as
    // well double-counts both the job count and the hour total. isJobVisibleOnSchedule() also
    // keeps the pre-existing Projected exclusion.
    array = array.filter(job => this.isJobVisibleOnSchedule(job));

    var sum = 0;
    array.forEach(function (job) {
        sum += parseFloat(job.estimatedtime) || 0
    })

    var hours = Math.floor(sum);
    var minutes = (sum * 60) % 60;

    let jobText = 'jobs';
    if(array.length == 1){
      jobText = 'job';
    }

    let jt = array.length > 0 ? array.length + ' ' + jobText +  " (" + hours + "hr " + Math.floor(minutes) + "min) scheduled" : "No jobs scheduled";

    //get QI hours 
    let sumQI = 0;
    let self = this;
    array.forEach(function(job) {
      if(self.isQIJob(job)){
        sumQI += parseFloat(job.estimatedtime) || 0
      }
    })

    let qiHours = Math.floor(sumQI);
    let qiMinutes = (sumQI * 60) % 60;

    let qi = '';
    if(sumQI > 0){
      qi = qiHours > 0 ? "QI: " + qiHours + "hr ": "";
      qi += qiMinutes > 0 ? Math.floor(qiMinutes) + "min" : "";
    }else {
    qi = "";
    }

    var sumMF = 0;
    array.forEach(function (job) {
      if(job.customer_jobtype.toLowerCase().includes('mf')){
        sumMF += parseFloat(job.estimatedtime) || 0
      }
    })

    var mfHours = Math.floor(sumMF);
    var mfMinutes = (sumMF * 60) % 60;

    let mf = '';
    if(sumMF > 0){
      mf = mfHours > 0 ? "Multifamily: " + mfHours + "hr " : "";
      mf += mfMinutes > 0 ? Math.floor(mfMinutes) + "min" : "";
    }else {
      mf = "";
    }

    var sumEG = 0;

    //subtract sumQI and sumMF from sum
    sumEG = sum - sumQI - sumMF;
    var egHours = Math.floor(sumEG);
    var egMinutes = (sumEG * 60) % 60;

    let eg = ''
    if(sumEG > 0){
      eg = egHours > 0 ? "Energy / Other: " + egHours + "hr ": "";
      eg += egMinutes > 0 ? Math.floor(egMinutes) + "min" : "";
    }else {
      eg = "";
    }
    let obj = {
      jt: jt,
      qi: qi,
      mf: mf,
      eg: eg  
    }
    
    return obj;
  
  }
//
  updateStartTimeNew(job) {

    this.areTimeButtonsDisabled = true;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.messager.openSnackBar('Clocking in...', '', 'successAlert');


    if(this.daystarted){

      this.scheduleService.updateStartTime(job, this.employeeID, timezone).subscribe(
        res => {
          if(res.Error){
            this.messager.openSnackBar('Error: ' + res.Message, '', 'errorAlert');
            this.logger.error(this.usernamee + 'attempted to clocked into ' + job.job_id + "Error: " + res.Message );
            this.areTimeButtonsDisabled = false;
          } else {
            //update first job status
            if(this.firstJobDone == false){

            this.logger.info(this.usernamee + ' clocked into their FIRST JOB.');
              this.scheduleService.updateTimeToFirstJob(this.employeeID, res.Date, timezone).subscribe(
                (res) => {
                  this.firstJobDone = true;
                  this.areTimeButtonsDisabled = false;

                }, err => {
                  this.messager.openSnackBar('Error occurred. This has been logged', '', 'errorAlert');
                  this.logger.info(this.usernamee + ' experienced an error clocking into their first job: '+ err);
                  this.areTimeButtonsDisabled = false;

                }
              )

            }else {
              //update travel time.
              this.scheduleService.updateTravelTime(this.employeeID, res.Date, timezone).subscribe(
                res => {
                  this.areTimeButtonsDisabled = false;
                }, err => {
                  this.logger.info(this.usernamee + ' experienced an error updating travel time to : ' + job.job_id + ' ' + err);
                  this.areTimeButtonsDisabled = false;

                }
              )
            }


            job.clockedin = true;
            job.starttime = res.Date;
            this.messager.openSnackBar('Clocked In', '', 'successAlert');
            this.logger.info(this.usernamee + ' clocked into ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);

            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);
              }, err => {
                this.logger.info(this.usernamee + ' experienced an error becoming a participant of : ' + job.job_id + ' ' + err);
              }
            )
          }
        },
        err => {
          this.messager.openSnackBar('Could not clock in: ' + err, '', 'errorAlert');
          this.areTimeButtonsDisabled = false;

        }
      );

    }else {
      this.messager.openSnackBar('Please start your day first', '', 'errorAlert');
      this.areTimeButtonsDisabled = false;
    }

  }

  isParticipant(participants, empID): boolean{
    return participants? participants.includes(empID) : false;
  }

  updateEndTimeNew(job) {
    this.areTimeButtonsDisabled = true;
    this.messager.openSnackBar('Clocking out...', '', 'successAlert');


    //check to make sure no one is clocked in

      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      //update time file for this job
      this.scheduleService.updateEndTime(job, this.employeeID, timezone).subscribe(
      res => {

        if(!res.Error){

          job.clockedin = false;
          this.messager.openSnackBar('Clocked Out! Time on job: ' + (res.Total.hours || '00' + ' hour(s) ') + (typeof res.Total.minutes === 'undefined' ? '' : (res.Total.minutes + " min")) + " " + res.Total.seconds + " sec", '', 'successAlert');
          this.logger.info(this.usernamee + ' clocked out of ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);
          this.areTimeButtonsDisabled = false;

          //add total time to 'jobtime' in 'day' entry in table AND update lastClockout
            this.scheduleService.getParticipants(job.job_id).subscribe(
              res => {
                this.areTimeButtonsDisabled = false;
                job.participants = res.Participants.participants;
                this.scheduleService.checkClockedIn(timezone);
              }, err => {
                this.areTimeButtonsDisabled = false;
                this.logger.error(this.usernamee + 'experienced an api error attempting to clock out of ' + job.job_id + "Error: " + err);
              }
            )
        }else {
          this.areTimeButtonsDisabled = false;
          this.logger.error(this.usernamee + 'attempted to clock out of ' + job.job_id + "Error: " + res.Message);
        }



      },
      err => {
        this.messager.openSnackBar('Could not clock out: ' + err, '', 'errorAlert');
        this.areTimeButtonsDisabled = false;
      }
    );

    this.scheduleService.getIsClockedIn().subscribe(
      res => {
        this.isClockedIn = res;
      }, err => {
        this.isClockedIn = false;
      }
    );

  }

  startDay(version){

    let userl = this.user;
    let empid = this.employeeID;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const who = this.usernamee || (this.user && this.user.nickname) || 'Unknown user';
    const httpMsg = (err) => (err && err.error && err.error.Message) || (err && err.message) || String(err);

    // Logged before the dialog so cancelled or abandoned taps are visible too.
    this.logger.info(who + (version == 1 ? ' tapped Start Work Day' : ' tapped End Work Day'));

    const dialogRef = this.dialog.open(StartDayWarningDialogComponent, {
      minWidth: '300px',
      height: '250px',
      data : {
        version: version
      }
    }).afterClosed().subscribe(
      result => {
        if (result == 2){
          this.logger.info(who + (version == 1 ? ' cancelled Start Work Day' : ' cancelled End Work Day'));
        } else if (result !== 1) {
          this.logger.info(who + ' dismissed the ' + (version == 1 ? 'Start' : 'End') + ' Work Day dialog without confirming');
        } else {

          if(version == 1){

            //start day
            this.logger.info(who + ' attempted to start day');
            if(!empid){
              // Profile not loaded yet: the id would go out as "undefined" and the backend query would fail.
              this.messager.openSnackBar('Still loading your profile, please try again in a moment.', '', 'errorAlert');
              this.logger.error(who + ' start day blocked: employee id not loaded yet');
              return;
            }
            this.scheduleService.checkDayStatus(empid, timezone).subscribe(
              res => {

                if(res.Error){
                  this.messager.openSnackBar(res.Message, '', 'errorAlert');
                  this.logger.error(who + ' ' + res.Message);
                }else {


                  if(res.Status == 'Ended'){
                    this.scheduleService.startDayAfterEnded(timezone).subscribe(
                      res => {
                        if(!res.Error){
                        this.daystarted = true; 
                        this.messager.openSnackBar('Resuming current day.', '', 'successAlert');
                        this.logger.info(who + ' restarted day.');
                        }else{
                          this.messager.openSnackBar(res.Message, '', 'errorAlert');
                          this.logger.error(who + ' ' + res.Message);
                        }
                      }, err => {
                        this.messager.openSnackBar('Could not restart day: ' + httpMsg(err), '', 'errorAlert');
                        this.logger.error(who + ' restart day HTTP error: ' + httpMsg(err));
                      }
                    ); 

                  }else {

                    this.scheduleService.createDayEntry(empid, timezone).subscribe(
                      res => {
                        if(!res.Error){
                          this.daystarted = true;
                          this.messager.openSnackBar(res.Message, '', 'successAlert');
                          if(String(res.Message || '').indexOf('Day already started') === 0){
                            // A row already existed: this was a retry, not a fresh start.
                            this.logger.warn(who + ' ' + res.Message);
                          }else{
                            this.logger.info(who + ' ' + res.Message);
                          }
                        }else {
                          this.messager.openSnackBar(res.Message, '', 'errorAlert');
                          this.logger.error(who + ' ' + res.Message);
                        }
                      }, err => {
                        this.messager.openSnackBar('Could not start day: ' + httpMsg(err), '', 'errorAlert');
                        this.logger.error(who + ' start day HTTP error: ' + httpMsg(err));
                      }
                    )
                    
                  }

                }
              }, err => {
                this.messager.openSnackBar('Could not check day status: ' + httpMsg(err), '', 'errorAlert');
                this.logger.error(who + ' check day status HTTP error: ' + httpMsg(err));
              }
            );

          }else {
            //end day — check for leftover scheduled jobs first
            this.logger.info(this.usernamee + ' attempted to end day');
            const skipJobsCheck = empid == 176 || this.user?.nickname == 'richardf';
            if (skipJobsCheck) {
              this.scheduleService.endDayEntry(empid, timezone).subscribe(
                res => {
                  if (!res.Error) {
                    this.daystarted = false;
                    this.messager.openSnackBar(res.Message, '', 'successAlert');
                    this.logger.info(this.usernamee + ' ' + res.Message);
                  } else {
                    this.messager.openSnackBar(res.Message, '', 'errorAlert');
                    this.logger.error(this.usernamee + ' ' + res.Message);
                  }
                }, err => {
                  const message = err.error?.Message || err.message || 'Could not end day. Please try again.';
                  this.messager.openSnackBar(message, '', 'errorAlert');
                  this.logger.error(this.usernamee + ' End Day HTTP error: ' + message);
                }
              );
            } else
            this.scheduleService.getScheduledJobsForEmployee(empid).subscribe(
              (checkRes: any) => {
                const scheduledJobs = (!checkRes.Error && checkRes.Jobs && checkRes.Jobs.length > 0) ? checkRes.Jobs : [];
                const doEndDay = () => {
                  this.scheduleService.endDayEntry(empid, timezone).subscribe(
                    res => {
                      if(!res.Error){
                        this.daystarted = false;
                        this.messager.openSnackBar(res.Message, '', 'successAlert');
                        this.logger.info(this.usernamee + ' ' + res.Message);
                      }else {
                        this.messager.openSnackBar(res.Message, '', 'errorAlert');
                        this.logger.error(this.usernamee + ' ' + res.Message);
                      }
                    }, err => {
                      const message = err.error?.Message || err.message || 'Could not end day. Please try again.';
                      this.messager.openSnackBar(message, '', 'errorAlert');
                      this.logger.error(this.usernamee + ' End Day HTTP error: ' + message);
                    }
                  );
                };

                if (scheduledJobs.length > 0) {
                  this.dialog.open(ScheduledJobsWarningDialogComponent, {
                    minWidth: '500px',
                    data: { jobs: scheduledJobs }
                  }).afterClosed().subscribe(choice => {
                    if (choice === 1) {
                      doEndDay();
                    }
                  });
                } else {
                  doEndDay();
                }
              }, () => {
                // If the check fails, proceed with end day as normal
                this.scheduleService.endDayEntry(empid, timezone).subscribe(
                  res => {
                    if(!res.Error){
                      this.daystarted = false;
                      this.messager.openSnackBar(res.Message, '', 'successAlert');
                    }else {
                      this.messager.openSnackBar(res.Message, '', 'errorAlert');
                    }
                  }
                );
              }
            );

          }
        }

      }
    );
  }

  requestTraining(): void {
    const empId = this.auth.getEmployeeId();
    
    if (!empId) {
      this.messager.openSnackBar('Unable to send request.', '', 'errorAlert');
      return;
    }
    
    // Fetch employee name from database to ensure we have the correct name
    this.employeeService.getOneEmployee(Number(empId)).subscribe(
      (empData: any) => {
        let empName = 'Employee ' + empId; // Default fallback
        
        // Get name from database, prioritizing employee_name
        if (empData && empData.employee_name) {
          const dbName = String(empData.employee_name).trim();
          // Only use if it's not an email address
          if (dbName && dbName.indexOf('@') === -1) {
            empName = dbName;
          } else if (empData.initials && String(empData.initials).trim()) {
            // Fallback to initials if name is invalid
            empName = String(empData.initials).trim();
          }
        }
        
        const defaultMessage = `Assign next training course to ${empName}`;
        const dialogRef = this.dialog.open(TrainingRequestModalComponent, {
          width: '600px',
          data: {
            employeeId: Number(empId),
            employeeName: empName,
            defaultMessage: defaultMessage
          } as TrainingRequestModalData
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.message) {
            // User clicked Send with a message (custom or default)
            // Backend will fetch the correct name from database, so we can pass empName as fallback
            this.trainingService.createTrainingNotification(Number(empId), empName, result.message).subscribe(
              (res) => {
                if (res && !res.Error) {
                  this.messager.openSnackBar('Training request sent to your manager.', '', 'successAlert');
                } else {
                  this.messager.openSnackBar((res && res.Message) || 'Request failed.', '', 'errorAlert');
                }
              },
              () => this.messager.openSnackBar('Request failed.', '', 'errorAlert')
            );
          }
          // If result is null/undefined, user clicked Cancel - do nothing
        });
      },
      (error) => {
        // If employee fetch fails, still allow the request but use generic name
        const empName = 'Employee ' + empId;
        const defaultMessage = `Assign next training course to ${empName}`;
        const dialogRef = this.dialog.open(TrainingRequestModalComponent, {
          width: '600px',
          data: {
            employeeId: Number(empId),
            employeeName: empName,
            defaultMessage: defaultMessage
          } as TrainingRequestModalData
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.message) {
            this.trainingService.createTrainingNotification(Number(empId), empName, result.message).subscribe(
              (res) => {
                if (res && !res.Error) {
                  this.messager.openSnackBar('Training request sent to your manager.', '', 'successAlert');
                } else {
                  this.messager.openSnackBar((res && res.Message) || 'Request failed.', '', 'errorAlert');
                }
              },
              () => this.messager.openSnackBar('Request failed.', '', 'errorAlert')
            );
          }
        });
      }
    );
  }

  
  //filter jobs by sitevisitrqd
  filterJobsBySiteVisit(): void {
    this.filterBySiteVisit = !this.filterBySiteVisit;
    this.isToggleOn = this.filterBySiteVisit;
    this.renderJobs();
  }

  // Show only jobs whose status is still "Scheduled".
  toggleScheduledOnly(): void {
    this.scheduledOnly = !this.scheduledOnly;
    this.renderJobs();
  }


  toggleLoadAll(): void {
    this.loadFullList = !this.loadFullList;
    if(this.loadFullList){
      this.initialAllLoaded = true;
      this.scheduleService.setInitialLoaded(true);
    }
    this.renderJobs();
  }

  doBatchEdit(): void {
    //open batch edit
    const dialogRef = this.dialog.open(BatchEditComponent, {
      minWidth: '90vw',
      height: '90vh',
      data: {
        items: this.editJobIds,
        mandatoryJobIds: this.mandatoryJobIds,
        isScheduler: this.isScheduler
      }
    }).afterClosed().subscribe(
      res => {
        this.clearBatch()
      });
  }

  clearBatch(): void {
    this.editJobIds.length = 0;
    this.mandatoryJobIds.length = 0;
    this.checkboxes.forEach(checkbox => checkbox.checked = false);
    this.toggleBatchEditing();

  }

  sendAuditEmail(job_id, location_id): void {
    this.messager.openSnackBar('Sending audit email...', '', 'successAlert');
    //save Current Data:
      this.locationService.sendAuditEmail(location_id, job_id).subscribe(
        res => {
          this.messager.openSnackBar('Audit email sent!', '', 'successAlert');
        }, err => {
        })
  }

  toggleBatchEditing(): void {
    this.batchEditing = !this.batchEditing;
  }

  getCheckedIndexes(job): void {

		var isInJobArray = this.editJobIds.indexOf(job.job_id);
		if( isInJobArray == -1 )
		{
			//alertify.warning('new item');
			this.editJobIds.push(job.job_id);
			if(this.jobHasTag(job, MANDATORY_JOB_TAG_ID)){
				this.mandatoryJobIds.push(job.job_id);
			}
		}
		else
		{
			//alertify.warning('new item');
			this.editJobIds.splice(isInJobArray,1);
			const mandatoryIndex = this.mandatoryJobIds.indexOf(job.job_id);
			if(mandatoryIndex > -1){ this.mandatoryJobIds.splice(mandatoryIndex, 1); }
		}
  }

  copyText(job_id): void {
    navigator.clipboard.writeText(job_id);
    this.messager.openSnackBar('Copied '  + job_id  + ' to clipboard', '', 'successAlert');
  }

  toggleFullDetails(): void {
    this.openFullDetails = !this.openFullDetails
  }
  
  onEmailClick(job): void {

    this.messager.openSnackBar('Sending email...', '', 'successAlert', 60000);
    this.cdr.detectChanges();
    job.photos = {};
    job.jb = {};
    job.rf = {};
    job.notes = {};
    job.triggered_by = this.usernamee;

    // Lennar Final/PDWI n8n webhook (all markets). Fires on the pristine builder contact
    // (before the CC list is assembled below).
    this.notifyLennarWebhook(job);

    if(job.repemaildist && job.repemaildist.length > 0){
      job.contact_e_mail += ',' + job.repemaildist;
    }

    job.contact_e_mail += ',' + job.e_mail;

    //remove all contacts from generator jobs. 
    if(job.customer_jobtype.toLowerCase().includes('generator')){
      job.contact_e_mail = job.e_mail;
    }
    

    var isCustom = job.customer_jobtype.toLowerCase().includes('cust') && !job.customer_jobtype.toLowerCase().includes('customer');
    var isProd = job.customer_jobtype.toLowerCase().includes('prod');
    //Matt Hudgins TRUE Homes distribution request. 
    // Raleigh, Triad, Charlotte North, Charlotte South, Charlotte West
    if(job.customer_name.toLowerCase().includes('true')){

      let region; 
      this.scheduleService.getTrueHomesRegions(job.subdivision).subscribe(
        res => {
          if(!res.Error || res.Region.bldr_region.length > 1){
            
            region = res.Region.bldr_region.toLowerCase();
            if(region.includes('triad')){
              job.contact_e_mail = job.contact_e_mail.trim() + ",bmcguffin@truehomesusa.com,bmcwhirter@truehomesusa.com,rsands@truehomesusa.com";
            }else if(region.includes('north')){
              job.contact_e_mail = job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,cbuttrill@truehomesusa.com,ccole@truehomesusa.com";
            }else if(region.includes('south')){
              job.contact_e_mail = job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,wgross@truehomesusa.com,scoberth@truehomesusa.com";
            }else if(region.includes('west')){
              job.contact_e_mail = job.contact_e_mail.trim() + ",rsimmons@truehomesusa.com,rmulhern@truehomesusa.com,bcrysler@truehomesusa.com,bshuman@truehomesusa.com";
            }

          }
        }
      )

    }

    
    if(job.customer_name.toLowerCase().includes('true triad')){
        job.contact_e_mail = job.contact_e_mail.trim() + ""
    }

    if(job.customer_name.toLowerCase().includes('dr horton col')){
      if(job.customer_jobtype.toLowerCase().includes('db&bd')){
        job.contact_e_mail = job.contact_e_mail.trim() + ",AHFloyd@drhorton.com,SNBishop@drhorton.com,"
      }
    }

    if(job.customer_name.toLowerCase().includes('mattamy')){
        job.contact_e_mail = job.contact_e_mail.trim() + ",Justin.Russell@mattamycorp.com,Jason.Cooper@mattamycorp.com,Matthew.Byington@mattamycorp.com,";
    }

    if(job.customer_name.toLowerCase().trim().includes('true charlotte')){
      job.contact_e_mail = job.contact_e_mail.trim() + ",Connorm@theperformancepoint.com,ekillian@advancedmechanicalusa.com,lbentley@advancedmechanicalusa.com,";

      if(job.subdivision == 5080){
          job.contact_e_mail = job.contact_e_mail.trim() + ",BShuman@truehomesusa.com,"
      }

      if(job.subdivision == 99){
        job.contact_e_mail = job.contact_e_mail.trim() + ",connorm@theperformancepoint.com, jacobb@theperformancepoint.com";
      }

      if(job.customer_jobtype.toLowerCase().includes('pdwi')){
        job.contact_e_mail = job.contact_e_mail.trim() + ",Jessica.C@insulation-holdings.com,"
      }

    }

    //account for custom and prod review emails first
    if(isProd && job.job_status.includes('UnderRev') &&
     !job.customer_name.toLowerCase().includes('schell brothers-nashville')
     && !job.customer_name.toLowerCase().includes('beechwood')
     )
      {
                      
            this.scheduleService.sendEmail(job).subscribe(
              res => {
                if (res.Error) {
                  this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
                  this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                } else {
                  this.logger.info(this.usernamee + ' sent under review email for job id-' + job.job_id);
                  this.messager.openSnackBar('Under review email sent to builder', '', 'successAlert');
                }
              },err => {
                this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
              }
            );

    }else if(isCustom && job.job_status.includes('UnderRev') &&
     !job.customer_name.toLowerCase().includes('schell brothers-nashville')
     && !job.customer_jobtype.toLowerCase().includes('qi'))
    {
              this.scheduleService.sendEmail(job).subscribe(
                res => {
                  if (res.Error) {
                    this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
                    this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                  } else {
                  this.logger.info(this.usernamee + ' sent custom review email for job id-' + job.job_id);
                    this.messager.openSnackBar('Under review email sent to builder', '', 'successAlert');
                  }
                },err => {
                  this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
                }
              );
  
    }else {

      // If this is a trip job, fetch child jobs for consolidated email
      if(job.istrip){
        this.scheduleService.getTripJobs(job.job_id).subscribe(
          res => {
            if(!res.Error){ job.tripJobs = res.Jobs; }
            else { job.tripJobs = []; }
            this.sendResultsEmail(job);
          }, err => {
            job.tripJobs = [];
            this.sendResultsEmail(job);
          }
        );
      } else {
        this.sendResultsEmail(job);
      }

    }
    this.emailSentStatus[job.job_id] = true;
    this.cdr.detectChanges();

  }

  private sendResultsEmail(job): void {
      //getting picture record
      this.scheduleService.getRaterPicslocmainRF(job.locpics_id).subscribe(
        res => {
          if (res.Error) {
            this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
            this.messager.openSnackBar('There was an error getting pics: ' + res.Message, '', 'errorAlert');
            return;
          }

          job.photos = res.Photos;
          this.scheduleService.getRaterNotes(job.location_id).subscribe(
            res => {
              if (res.Error) {
                this.logger.error( this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                this.messager.openSnackBar('There was an error getting notes: ' + res.Message, '', 'errorAlert');
                return;
              }
              job.notes = res.Notes;
              var successString = 'Email Sent to ' + job.contact_e_mail + "," + job.contacts;

              this.scheduleService.getDataByFormID(job.form_id).subscribe(
                res => {
                  job.rf = res.formData;
                  if (res.Error) {
                    this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                    this.messager.openSnackBar('There was an error getting Rater form data: ' + res.Message, '', 'errorAlert');
                    return;
                  } else {


                    //THESE ARE RESULTS EMAIL REQUESTS. PLACE THESE IN A HELPER FUNCTION. 

                    if(job.customer_job == 3652 || job.customer_job == 3582){
                      job.contact_e_mail += ',jason.yurisic@schellbrothers.com,Timothy.Lampley@airtron.com';
                    }

                    if(job.customer_name.toLowerCase().trim().includes('lennar') && job.customer_name.toLowerCase().trim().includes('clt')){
                      job.contact_e_mail = job.contact_e_mail.trim() + ",randy.harrison@lennar.com";
                    }



                    //Matt F gets Mark, Andy and Richard
                    if(job.employee_id == 170 || job.employee_id == 176 || job.employee_id == 154 || job.employee_id == 204 || job.employee_id == 170){
                      job.contact_e_mail = job.contact_e_mail.trim() + ",carterw@theperformancepoint.com";
                    }

                    //Greg Dejong gets emails for Alex Miller and Kyle Estudilio
                    if(job.employee_id == 470 || job.employee_id == 458){
                      job.contact_e_mail += ",gregd@theperformancepoint.com,";
                    }

                    //DOROTHY HITE gets added to all emails for GREG HITE
                    if(job.employee_id == 140){
                      job.contact_e_mail += ",dorothyh@theperformancepoint.com,";
                    }

                    // Kevin, Nolan needs to go on all Poythress emails
                    if( job.customer_name.toLowerCase().trim().includes('poythress')  ){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',Nolan@pccbuilder.com,Kevin@pccbuilder.com';
                    }

                    if(job.customer_name.trim().includes('True') && (job.city.trim().includes('Winston-Salem') || job.city.trim().includes('Greensboro') || job.city.trim().includes('High Point')  ) ){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',rsands@truehomesusa.com,bmcwhirter@truehomesusa.com';
                    }

                    //True Homes offsite contact chains (keyed off subdivision name).
                    let trueOffsiteSub = (job.subdivision_name || '').toLowerCase();

                    //James Hood gets added to ALL True Homes HERO offsite results emails (any region).
                    //Subdivision must contain True + Offsite + HERO; "(NOT HERO)" subs are excluded.
                    if(trueOffsiteSub.includes('true') && trueOffsiteSub.includes('offsite') && trueOffsiteSub.includes('hero') && !trueOffsiteSub.includes('not hero')){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',jhood@truehomesusa.com';
                    }

                    //Ethan Worley gets added to True Triad HERO offsite results emails ("(NOT HERO)" excluded).
                    if(trueOffsiteSub.includes('true') && trueOffsiteSub.includes('triad') && trueOffsiteSub.includes('offsite') && trueOffsiteSub.includes('hero') && !trueOffsiteSub.includes('not hero')){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',Eworley@truehomesusa.com';
                    }

                    //Jesse Bishop gets added to True Coastal HERO offsite results emails ("(NOT HERO)" excluded).
                    if(trueOffsiteSub.includes('true') && trueOffsiteSub.includes('coastal') && trueOffsiteSub.includes('offsite') && trueOffsiteSub.includes('hero') && !trueOffsiteSub.includes('not hero')){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',Jbishop@truehomesusa.com';
                    }

                    let ewcsubs = [3613,1429,1601,3376,3630];
                    if(ewcsubs.includes(job.subdivision)){
                      job.contact_e_mail = job.contact_e_mail.trim();
                    }

                    let bobbyMcLureSubs = [3381, 3144];
                    if(bobbyMcLureSubs.includes(job.subdivision)){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',bobby.mcclure@meritagehomes.com';
                    }


                    //REMOVE bobby from Waterside 
                    if(job.subdivision == 3309){
                      job.contact_e_mail = job.contact_e_mail.toLowerCase().replace(/bobby.mcclure@meritagehomes.com/g, '');
                    }

                    //REMOVE JDFORD from DR Horton emails for these subdivisions.
                    if(job.subdivision == 4937 || job.subdivision == 4938 || job.subdivision == 4939){
                      job.contact_e_mail = job.contact_e_mail.toLowerCase().replace(/jdford@drhorton.com/g, ',jstevens@drhorton.com');
                    }

                    if(job.customer_name.trim().includes('DR Horton COL')){
                      job.contact_e_mail = job.contact_e_mail.trim() + ',MLAvirett@drhorton.com';
                    }

                    //ENSURE ALL Managers are copied in on results emails here:
                    this.employeeService.getSupervisorEmails(job.employee_id).subscribe(
                      res => {
                        job.contact_e_mail = job.contact_e_mail.trim() + ',' + res.Supervisor_Emails;

                            this.scheduleService.sendEmail(job).subscribe(  
                              res => {
                                if (res.Error) {
                                  this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
                                  this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                                } else {
                                  this.messager.openSnackBar(successString, '', 'successAlert');
                                }
                              },err => {
                                this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
                              }
                            );

                      }, err => {

                            this.scheduleService.sendEmail(job).subscribe(  
                              res => {
                                if (res.Error) {
                                  this.messager.openSnackBar('There was an error sending email: ' + res.Message, '', 'errorAlert');
                                  this.logger.error(this.usernamee + ' experienced an error sending schedule email for job id-' + job.job_id + ': ' + res.Message);
                                } else {
                                  this.messager.openSnackBar(successString, '', 'successAlert');
                                }
                              },err => {
                                this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
                              }
                            );

                      }
                    );
                  }
                }, err => {
                        this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
                }
              )

            }, err => {
              this.messager.openSnackBar('There was an app error retrieving notes for results email: ' + err, '', 'errorAlert');
            })
        }, err => {
          this.messager.openSnackBar('There was an app error sending email: ' + err, '', 'errorAlert');
        });
  }

  // Fire an n8n webhook for Lennar Final/PDWI jobs across all markets (Lennar-CLT, Lennar-GRV,
  // Lennar-RAL, etc.). Sends subdivision, lot, contact name, and contact email.
  // Fire-and-forget: any failure is logged and swallowed so it never affects the results email.
  // To disable, comment out the `this.notifyLennarWebhook(job)` call in onEmailClick.
  private notifyLennarWebhook(job): void {

    const customerName = (job.customer_name || '').toLowerCase();
    const jobType = (job.customer_jobtype || '').toLowerCase();

    const isLennar = customerName.includes('lennar-clt');          // all markets (Lennar-CLT, -GRV, -RAL, ...)
    const isPdwiOrFinal = jobType.includes('pdwi') || jobType.includes('final');

    if (!isLennar || !isPdwiOrFinal) {
      return;
    }

    const payload = {
      job_id: job.job_id,
      subdivision: job.subdivision_name,
      lot: job.lot,
      jobType: job.customer_jobtype,
      contactName: job.name,          // contacts.name (the human name; job.contact_name is the id)
      contactEmail: job.contact_e_mail // pristine builder contact (called before the CC list is built)
    };

    // Routed through our backend (/rhAPI/lennarWebhook), which forwards to n8n server-side —
    // no browser CORS/preflight. Fire-and-forget: a failure never affects the results email.
    this.scheduleService.postLennarWebhook(payload).subscribe(
      res => {
        if (res && res.status === 'Error') {
          this.logger.error(this.usernamee + ' Lennar webhook error for job id-' + job.job_id + ': ' + res.message);
        } else {
          this.logger.info(this.usernamee + ' hit Lennar webhook for job id-' + job.job_id + ' (' + job.customer_name + ' / ' + job.customer_jobtype + ')');
        }
      },
      err => {
        this.logger.error(this.usernamee + ' error hitting Lennar webhook for job id-' + job.job_id + ': ' + err);
      }
    );
  }

  photosModalOpen(){
    
  }
  
  onPhotosClick(job): void {

    if(this.viewingPhotos == true){
      this.messager.openSnackBar('Loading photos for location...', '', 'successAlert');
      this.scheduleService.getRaterPicslocmain(job.locpics_id).subscribe(
        res => {

            if(res.error){
              this.messager.openSnackBar(res.message, '', 'errorAlert');
            }else{
              const photosArray = Object.keys(res.Photos).map(key => ({
                  name: key,
                  image: res.Photos[key]
              }));
  
              res.Photos.locmain = true;
              const dialogRef = this.dialog.open(RatingPhotosDialogComponent, {
                minWidth: '100vw',
                height: '100vh',
                panelClass: 'rating-photos-panel',
                data: {
                  photos : photosArray,
                  job:  job
                },
              });
            }
        }, err => {
              this.messager.openSnackBar('Error', '', 'errorAlert');
        })

    }else{
      //open Add 
      let newjob = {
        ...job,
        logged_in : this.employeeID
      }
      this.addConditionPhotos(newjob);
    }

  }

  closeSubDivModal(): void {
    const modal = document.getElementById('viewsubdivisionmodal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  openSubDivModal(job): void {  
       const modal = document.getElementById('viewsubdivisionmodal');
       if(modal){
        modal.style.display = 'block';
       }
  }

  closePhotoModal(): void {
    const modal = document.getElementById('photosModal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  showPhotosModal(job) : void {

    this.modalJob = job;

    if(job.locpics_id){
      const modal = document.getElementById('photosModal');
      if(modal){
        modal.style.display = 'block';
      }
      return;
    }else{

      //deep search
      this.scheduleService.searchPicsID(job.location_id).subscribe(
        res => {
          if((!res.Error && res.id > 0) && res.id > 0){
  
            const modal = document.getElementById('photosModal');
            if(modal){
              modal.style.display = 'block';
            }
  
          }else{ //no pics, insert them
            this.viewingPhotos = false;
            this.scheduleService.insertLocPics(job.location_id, job.job_id).subscribe(
              res => {
                if(res.Error){
                  this.messager.openSnackBar('Error: ' + res.Message, '', 'errorAlert');
                  return;
                }else {
                  this.scheduleService.setPicsLocmain(job.location_id, res.Data.id).subscribe(
                    res2 => {
                      job.locpics_id = res.Data.id;
                      this.modalJob = job;
                      if(res2.Error){
                        this.messager.openSnackBar('Error setting picture record: ' + 
                          res2.Message, '', 'errorAlert');
                        return;
                      }else {
                        const modal = document.getElementById('photosModal');
                        if(modal){
                          modal.style.display = 'block';
                        }
                        return;
                      }
                    }
                  );
                }
              }
            );
          }
        });
    }

  }

  handleModalResponse(response : boolean) : void {
    const modal = document.getElementById('photosModal');
    if(modal){
      modal.style.display = 'none';
    }
    
    if(response){
      this.viewingPhotos = true;
    }else {
      this.viewingPhotos = false;
    }

    this.onPhotosClick(this.modalJob);

  }

addConditionPhotos(job): void {

  //the idea is to create a form with the job_id and auth, then submit it to the server
  // hack way to do it but it works. 
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = this.locationService.jobConditionPhotoslink;  //this.baseURL + '/m/upload-photos-form';
  form.target = 'photouploadwindow';
  
  // Create hidden input fields
  const fields = [
    { name: 'location_id', value: job.location_id },
    { name: 'job_id', value: job.job_id },
    { name: 'logged_in', value: job.logged_in },
    { name: 'street_address', value: job.street_address || '' },
    { name: 'customer_jobtype', value: job.customer_jobtype },
    { name: 'customer_name', value: job.customer_name },
  ];

  fields.forEach(field => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = field.name;
    input.value = field.value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

}


  // A job with a trip_id is a trip CHILD — its trip parent (istrip=true) already renders its
  // own card, so the child must not get one too. Also excludes Projected jobs (pre-existing
  // behavior). Used to gate the outer per-job grid cell in the template (not just the inner
  // mat-card), so an excluded job leaves no blank flex-item box on the page.
  // Keeps a card's DOM when its job object is replaced
  trackByJobId(index: number, job: any): any {
    return job ? job.job_id : index;
  }

  selectActive(job, kind: string): boolean {
    return this.lazySelects.has(job.job_id + ':' + kind);
  }

  // Swap the text stand-in for a real mat-select
  activateSelect(job, kind: string): void {
    this.lazySelects.add(job.job_id + ':' + kind);
  }

  isJobVisibleOnSchedule(job): boolean {
    return !(job?.job_status || '').includes('Projected') && !(job?.trip_id > 0);
  }

  // Whether `job` (at jobsToday[indexOfElement]) is the last one that will actually render —
  // i.e. no later job in the (unfiltered) array is itself visible. Used for the infinite-scroll
  // intersection-observer trigger card, so it still mounts even when the true last array entry
  // happens to be a hidden trip child/Projected job.
  isLastVisibleScheduleJob(indexOfElement: number): boolean {
    for (let i = indexOfElement + 1; i < this.jobsToday.length; i++) {
      if (this.isJobVisibleOnSchedule(this.jobsToday[i])) { return false; }
    }
    return true;
  }

  getStatusClass(job): string {
    if (!job.job_status) return '';
    const s = job.job_status.trim();
    switch (s) {
      case 'Complete':
      case 'Pass':
      case 'UnderRev':
      case 'Canceled':
      case 'EngStamp':
      case 'PendInfo':
      case 'PendPaym':
      case 'Rea4Review':
        return 'status-green';
      case 'EPO hold':
      case 'Fail':
      case 'Fail-NR':
      case 'On hold':
        return 'status-red';
      default:
        return '';
    }
  }

  // True when the job carries the given tag id. jobs.tags may arrive as a JS array,
  // a pg-array string ('{7,57}'), or a CSV string — handle all three.
  jobHasTag(job, tagId): boolean {
    if (!job || job.tags == null) return false;
    let ids = job.tags;
    if (typeof ids === 'string') {
      ids = ids.replace(/[{}]/g, '').split(',');
    }
    if (!Array.isArray(ids)) return false;
    return ids.some(id => Number(id) === Number(tagId));
  }

  // Job types whose status dropdown on the schedule job card is the compliance/report
  // list instead of the field Pass/Fail list.
  //
  // NOTE: this set is deliberately NOT identical to EditJobDialogComponent's
  // COMPLIANCE_STATUS_KEYWORDS — it has always omitted 'tradeoff modeling' (and
  // 'manual'), a known pre-existing discrepancy carried on its own card. Don't
  // "fix" it here.
  //
  // 'prelim_mf' / 'prelim updates_mf' are deliberately narrow: a bare 'prelim' would
  // swallow Prelim/Prelim_cust/Prelim HERO-* and the site-visit job Preliminary Testing_MF.
  SCHEDULE_COMPLIANCE_STATUS_KEYWORDS = [
    'report', 'n/s', 'rescheck', 'modeling_mf',
    'model updates', 'prelim_mf', 'prelim updates_mf', 'sampling application'
  ];

  isComplianceStatusJobtype(customerJobtype: string): boolean {
    const cjt = (customerJobtype || '').toLowerCase();
    return this.SCHEDULE_COMPLIANCE_STATUS_KEYWORDS.some(keyword => cjt.includes(keyword));
  }

  getConfClass(job): string {

    if (job.conf_status) {

      switch (job.conf_status) {
        case 'Builder confirmed':
          return 'pos';
        case 'Not confirmed, call first':
          return 'cau';
        case 'Not ready':
          return 'neg';
        default:
          return '';
      }

    } else {
      return '';
    }


  }

  openDrainCam(job): void {

    this.scheduleService.getDrainCamData(job.job_id).subscribe(
      res => {

        if (!res.Error) {


          const dialogRef = this.dialog.open(DrainCamComponent, {
            minWidth: '500px',
            height: '100vh',
            data: res.Data
          });


        }
      }, err => {
      })

  }


  openSafetyInspection(job): void {

    this.scheduleService.getSafteyInspectionData(job.job_id).subscribe(
      res => {

        if (!res.Error) {

          const dialogRef = this.dialog.open(SafetyInspectionComponent, {
            minWidth: '500px',
            height: '100vh',
            data: res.Data
          });


        }
      }, err => {
      })

  }


  getSchedClass(job): string {

    let returnString;
    switch (job.job_status.trim()) {

      case 'Pass':
        returnString = 'pos';
        break;
      case 'Fail':
        returnString = 'neg';
        break;
      case 'Complete':
        returnString = 'pos';
        break;
      case 'Scheduled':
        returnString = 'cau';
        break;
    }

    return returnString;

  }

  gotoEko(job): string  {
    return 'https://app.ekotrope.com/#project:' + job.ekotrope_id;
  }

  gotoGDrive(job): string {
    return 'https://drive.google.com/drive/u/0/folders/' + job.folderid;
  }

  updateStatus(event, job, status): void {
    job.conf_status = status;
    //update conf status here:

    this.scheduleService.updateConfStatus(job.job_id, status).subscribe(
      res => {
        this.messager.openSnackBar('Successfully updated to ' + job, '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Status not updated: ' + err, '', 'errorAlert');
      });

  }


  /*
   * Card tQPtadd5 - did this pre-drywall status change mean the inspector went out?
   *
   * Written as a BLOCKLIST of the "it never happened" statuses rather than an
   * allowlist of terminal ones, so a terminal status added later counts
   * automatically instead of being silently excluded. Pass, Complete and every
   * Fail* variant therefore all count as conducted - Fail* is deliberate: pdwdone
   * also drives the builder-facing Builder Checklist filter
   * (builderchecklists.component.ts), and a failed pre-drywall is exactly when the
   * builder still needs their checklist. This is intentionally WIDER than the
   * Pass/Complete rule the HERO-final warning uses (jobEntry.getPdwCompleted):
   * pdwdone means "a PDWI happened", the warning asks "did one pass".
   */
  pdwStatusCountsAsConducted(status: string): boolean {
    const s = (status || '').trim().toLowerCase();
    if(!s){ return false; }
    if(s.includes('hold')){ return false; }   //On hold, EPO hold
    return ![
      'scheduled',
      'projected',
      'canceled',
      'cancelled',
      'not ready',
      'archive'
    ].includes(s);
  }

  // Non-blocking warning fired alongside the save, never gating it. The backend decides
  // whether it applies; see checkSamplingApplication in locations.js.
  checkSamplingApplication(item): void {
    if(!item || !item.location_id) { return; }
    if(!(item.job_status || '').toString().toLowerCase().includes('scheduled')) { return; }

    this.locationService.checkSamplingApplication(item.location_id, item.job_id, item.customer_job).subscribe(
      res => {
        if(res && !res.Error && res.needsFlag){
          this.logger.warn(this.usernamee + ' was warned that the sampling application is not complete for job id-' + item.job_id);
          this.dialog.open(WarningPopupComponent, {
            width: '500px',
            data: {
              warning_title: 'Sampling Application Not Complete',
              warning_description: '',
              warning_sub: 'Sampling Application is not complete and must be done before the first inspection. Notify the CT on the project'
                + (res.ctName ? ' (' + res.ctName + ')' : '') + '.',
              confirmText: 'Ok',
              showCancelButton: false
            }
          });
        }
      }, err => {}
    );
  }

  // Rater-schedule only. Runs after the status save and never gates it; a lookup failure means no prompt.
  maybePromptForSelfie(item): void {
    if(this.version != SCHEDTYPE.Normal){ return; }
    if(!item || !item.job_id || !item.customer_jobtype){ return; }
    // Energy jobs only: isEnergyJob drops the QI family, office jobtypes and every MF / ESMFNC jobtype.
    if(!this.isEnergyJob(item)){ return; }
    if(!this.pdwStatusCountsAsConducted(item.job_status)){ return; }

    this.scheduleService.getSelfieByJob(item.job_id).subscribe(
      res => {
        if(!res || res.Error || res.HasSelfie){ return; }

        this.dialog.open(WarningPopupComponent, {
          width: '500px',
          data: {
            warning_title: 'No Selfie For This Job',
            warning_description: '',
            warning_sub: 'No selfie has been taken for this job. Do you need to take one now?',
            confirmText: 'Yes, take picture',
            cancelText: 'No',
            showCancelButton: true
          }
        }).afterClosed().subscribe(async result => {
          if(result !== 2){
            this.logger.info(this.usernamee + ' declined the selfie prompt for job id-' + item.job_id
              + ' with location_id: ' + item.location_id);
            return;
          }
          const form_id = await this.ensureFormId(item);
          if(!form_id){
            this.messager.openSnackBar('Could not create or open a form for this job.', '', 'errorAlert');
            return;
          }
          this.dialog.open(SelfiePromptComponent, {
            minWidth: '90vw',
            data: { job: item, form_id: form_id, usernamee: this.usernamee }
          }).afterClosed().subscribe(r => {
            if(r && r.uploaded){
              this.logger.info(this.usernamee + ' took a selfie from the schedule status prompt for job id-'
                + item.job_id + ' with location_id: ' + item.location_id);
            }
          });
        });
      }, err => {}
    );
  }

  updateJobStatus(event, item): void {

      this.checkSamplingApplication(item);
      this.emailSentStatus[item.job_id] = false;
      this.scheduleService.setStatus(item.job_id, item).subscribe(
        res => {
          this.logger.info(this.usernamee + ' updated status for job id-' + item.job_id + ' to ' + item.job_status);
          this.messager.openSnackBar('Status updated!', '', 'successAlert');
        }, err => {
          this.logger.error(this.usernamee + ' encountered an error updating status for job id-' + item.job_id + ': ' + JSON.stringify(err));
          this.messager.openSnackBar('Status not updated!', '', 'warningAlert');
      });

      let jtype = item.customer_jobtype;
      let isPdw = jtype.includes('PDWI');
      var isCustom = jtype.toLowerCase().includes('cust') && !jtype.toLowerCase().includes('customer');
      var isProd = jtype.toLowerCase().includes('prod');

      if(item.job_status.toLowerCase().includes('cancel')){
        this.messager.openSnackBar('Cancelled status updated.', '', 'successAlert');
        this.locationService.updateCancelledStatus(item.job_id).subscribe(
          res => {
            this.messager.openSnackBar(res.Message, '', 'successAlert');
          }, err => {
            //this.messager.openSnackBar('Cancelled status not updated!', '', 'warningAlert');
          });
      }

      if(isProd && item.job_status.includes('UnderRev') && !item.customer_name.toLowerCase().includes('beechwood')){
        this.scheduleService.sendReviewEmail(item, EMAILTYPE.Prod).subscribe(
          (res) => {
                      if(res.Error){
                      this.messager.openSnackBar('An error occurred sending review email. ', '', 'errorAlert');
                      this.logger.error(`${this.usernamee} 
                         encountered an error sending production review email for ${item.street_address} job id- 
                         ${item.job_id} :  ${res.Message}`);
                      }else {
                        this.messager.openSnackBar('Production Review email sent', '', 'successAlert');
                        this.logger.info(this.usernamee + 
                          ' sent production review email for ' + item.street_address + ' job id- '
                          + item.job_id + ' successfully.'
                        )
                      }
          }, err => {
                      this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
                      this.logger.error(`${this.usernamee} encountered an error sending production review email for ${item.street_address}, job_id ${item.job_id} : ${err.message || err}`); 
          });
      }

      if(isPdw)
      {

          setTimeout(() => {
            this.trueCharlotteWestGradeICheck(item);
          }, 1000);

          /*
           * Card tQPtadd5 - only flip locmain.pdwdone when the new status says the
           * inspector was actually on site. This call used to fire on ANY status
           * change to a PDWI job, including Scheduled / Canceled / On hold, and
           * pdwdone is monotonic (nothing ever sets it back to false) - which is why
           * 3,458 dev locations carry pdwdone = true with no PDW ever conducted.
           */
          if(this.pdwStatusCountsAsConducted(item.job_status)){
            this.scheduleService.setPDWcomplete(item.location_id).subscribe(
            res => {
              this.messager.openSnackBar('Predrywall complete.', '', 'successAlert');
            }, err => {
              this.messager.openSnackBar('Predrywall status not updated!', '', 'warningAlert');
            });
          }

          if(item.job_status.includes('Fail') && !item.customer_jobtype.toLowerCase().includes('hers')){
            const dialogRef = this.dialog.open(ThermalDialogComponent, {
              minWidth: '500px',
              height: '50vh',
              data: item
            }).afterClosed().subscribe(
              result => {
                if(result == 1){
                  this.scheduleService.setThermalRequired(item.location_id,true).subscribe(
                    res => {
                        this.messager.openSnackBar('Rater will know a thermal is required.', '', 'successAlert');
                    }, err => {
                        this.messager.openSnackBar('Thermal status not updated!', '', 'warningAlert');
                    });
                  }
                });
          }
      }
      //All Beechwood emails go to Custom recipient list
      if(item.customer_name.toLowerCase().includes('beechwood') && !isCustom && !item.customer_jobtype.toLowerCase().includes('qi') ){
          this.scheduleService.sendReviewEmail(item, EMAILTYPE.Custom).subscribe(
            (res) => {
                        if(res.Error){
                        this.messager.openSnackBar('An error occurred sending review email! ', '', 'errorAlert');
                        }else {
                          this.messager.openSnackBar('Custom Review email sent', '', 'successAlert');
                        }
            }, err => {
                        this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
            });
      }

     if(item.customer_name.toLowerCase().includes('schell brothers-nashville') ){
        this.scheduleService.sendReviewEmail(item, 3).subscribe(
          (res) => {
                      if(res.Error){
                        this.messager.openSnackBar('An error occurred sending review email! ', '', 'errorAlert');
                      }else {
                        this.messager.openSnackBar('Custom Review email sent', '', 'successAlert');
                      }
          }, err => {
                      this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
          });
    }


      if(isCustom && !item.customer_name.toLowerCase().includes('schell brothers-nashville'))
      {
        if(item.job_status.includes('UnderRev')){
          this.scheduleService.getReviewers(item.job_id).subscribe(
            res => {
              item.reviewer = (res.Reviewer || '') + ',beth@theperformancepoint.com,jonb@theperformancepoint.com';
              this.scheduleService.sendReviewEmail(item, EMAILTYPE.Custom).subscribe(
                (res) => {
                            if(res.Error){
                            this.messager.openSnackBar('An error occurred sending review email! ', '', 'errorAlert');
                            }else {
                              this.messager.openSnackBar('Custom Review email sent', '', 'successAlert');
                            }
                }, err => {
                            this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
                });
              });
        }else {
          //get reviewers
          this.scheduleService.getReviewers(item.job_id).subscribe(
            res => {
              item.reviewer = (res.Reviewer || '') + ',beth@theperformancepoint.com,jonb@theperformancepoint.com';
              this.scheduleService.sendReviewEmail(item, EMAILTYPE.Custom).subscribe(
                (res) => {
                            if(res.Error){
                            this.messager.openSnackBar('An error occurred sending review email. ', '', 'errorAlert');
                            }else {
                              this.messager.openSnackBar('Custom Review email sent', '', 'successAlert');
                            }
                }, err => {
                            this.messager.openSnackBar('Error sending review email', '', 'errorAlert');
                });
            });
        }
      }

      // Any non-Scheduled status change on an _MF job notifies the subdivision
      // consultant. GPS customers are excluded.
      const isMF = jtype.toLowerCase().includes('_mf');
      const isGPS = (item.customer_name || '').toLowerCase().includes('gps');
      const mfStatus = (item.job_status || '').trim().toLowerCase();

      if(isMF && !isGPS && mfStatus !== 'scheduled'){
        this.scheduleService.sendReviewEmail(item, EMAILTYPE.MFConsultant).subscribe(
          (res) => {
            if(res.Skipped){
              this.messager.openSnackBar('No consultant set on this subdivision - consultant email not sent.', '', 'warningAlert');
            }else if(res.Error){
              this.messager.openSnackBar('An error occurred sending the MF consultant email.', '', 'errorAlert');
            }else {
              this.messager.openSnackBar('MF consultant email sent', '', 'successAlert');
            }
          }, err => {
            this.messager.openSnackBar('Error sending MF consultant email', '', 'errorAlert');
            this.logger.error(`${this.usernamee} encountered an error sending the MF consultant email for job_id ${item.job_id}: ${err.message || err}`);
          });
      }
      if(item.job_status.includes('Fail')){
        this.openFailReasonsPopup(item).afterClosed().subscribe(() => this.maybePromptForSelfie(item));
      }else{
        this.maybePromptForSelfie(item);
      }
  }

  trueCharlotteWestGradeICheck(job) {
    if(job.customer_name.toLowerCase().includes('true charlotte')){
      this.subService.getOneSubdivision(job.subdivision).subscribe(
        res => {
          if(!res.Error && res.Subdivision.bldr_region.toLowerCase().includes('west')){
            this.messager.openSnackBar('True Charlotte West Region - IF NOT GRADE 1, THEN FAIL THIS JOB.', 'Close', 'errorAlert', 10000);
          }
        });
    }
  }

  updateFailReason(event, item): void {
    this.scheduleService.setFailReason(item.job_id, item).subscribe(
      res => {
        this.messager.openSnackBar('Status updated!', '', 'successAlert');
      }, err => {
        this.messager.openSnackBar('Status not updated!', '', 'warningAlert');
      });
  }

async onFormClickAll(job) {
  try {
      if (job.form_id) {
          if (job.job_form_id == null) {
              let formObj = { form_id: job.form_id };
              const setFormResponse: any = await this.scheduleService.setForm(job.job_id, formObj).toPromise();
              this.logger.info(`${this.usernamee} set the form id for job ${job.job_id} to ${setFormResponse.form_id}`);
          }
          this.openDialogSequence(job);
      } else {
          try {
              const formLocationResponse: any = await this.scheduleService.getFormLocation(job.location_id).toPromise();
              if (job.job_form_id == null) {
                  let formObj = { form_id: formLocationResponse.form_id };
                  const setFormResponse: any = await this.scheduleService.setForm(job.job_id, formObj).toPromise();
                  this.logger.info(`${this.usernamee} set the form id for job ${job.job_id} to ${setFormResponse.form_id}`);
              }
              this.openDialogSequence(job);
          }catch (err) {
              this.openDialogSequence(job);
          }
      }
  } catch (error) {
      console.error('Error in onFormClickAll:', error);
      // You might want to handle the error more gracefully here
  }
}


  // Trip parents: child-task notes as "[jobtype]" sections (child rows keep their own notes).
  // A child whose note equals the trip's own is skipped: creating a trip copies the primary's notes.
  tripTaskNotes(job): { job_id: number, jobtype: string, job_notes: string }[] {
    if (!job?.istrip || !Array.isArray(job.trip_task_notes)) { return []; }
    const own = (job.job_notes || '').trim();
    return job.trip_task_notes.filter(n => n.job_notes && n.job_notes.trim() !== own);
  }

  saveNotes(value, job): void {
    this.messager.openSnackBar('Saved!', '', 'successAlert');

    job.job_notes = value;

    this.scheduleService.updateJobNotes(job.job_id, value).subscribe(
      res => {
      }, err => {
      })

  }

  onFormClick(job): void {


    //open form

    //this.log.info(this.usernamee + ' saved the following edits to contact ' + this.data.name.trim() + ' {' + changedProperties.toString() + '}' );

    this.scheduleService.getRaterformData(job).subscribe(
      (res) => {
        //this.dialogRef.close();
        this.messager.openSnackBar('Loading form...', '', 'successAlert');
        this.logger.info(this.usernamee + ' opened the form at ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' ');
        this.openDialog(res.formData, job.job_id, job.location_id,job.form_id);
      },
      err => {
        this.logger.error(this.usernamee + ' encountered an error opening the form ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' Err: ' + err.toString());
        this.messager.openSnackBar('Error: ' + err.message, '', 'errorAlert');
      }

    );

  }

  oldJobs(job): void {

    //open form
    this.scheduleService.getRaterformData(job).subscribe(
      (res) => {
        //this.dialogRef.close();
        //this.messager.openSnackBar('Loading form...', '', 'successAlert');
        this.logger.info(this.usernamee + ' used load data on job at ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' ');

        try {
          this.openDialog(job, job.job_id, job.location_id, job.form_id);
        }catch(error){
          this.messager.openSnackBar('Please click \'Form\' first, and THEN click \'Load Data\' ', '', 'errorAlert');
        }


        if(res.Error){
          this.messager.openSnackBar('Please open the form first, THEN click \'Load Data\' ', '', 'errorAlert');
        }
      },
      err => {
        this.logger.error(this.usernamee + ' encountered an error opening the form ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' Err: ' + err.toString());
        this.messager.openSnackBar('No old jobs to load:  ' + err.message, '', 'errorAlert');
      }
    );

  }

  openJobInNewTab(row): void {

    const sanitizedAddress = (row.street_address || 'No address').replace(/\//g, '-');
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/viewJobs/${sanitizedAddress}/${row.location_id}`])
    );
    window.open(url, '_blank');

  }

  dispatchQI(job): void {
    this.scheduleService.dispatchNewQI(job).subscribe(
      (res) => {
        this.messager.openSnackBar('Successfully dispatached!', '', 'successAlert');
      },
      err => {
        this.messager.openSnackBar('Error: ' + err.message, '', 'errorAlert');
      }
    )
  }

  openFailReasonsPopup(thisJob): MatDialogRef<FailReasonComponent> {
    return this.dialog.open(FailReasonComponent, {
      minWidth: '98vw',
      height: '95vh',
      data: {
        failreasons: this.failreasons,
        job: thisJob
      }
    });
  }

  // Keystroke in the name box: ngModel has already updated employeeFilter.
  search(_event?: KeyboardEvent): void {
    this.renderJobs();
  }


  viewTimeCard(): void {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.scheduleService.getTodaysTimecard(this.employeeID, timezone).subscribe(
      res => {
        let jobs = res.Data;
        this.scheduleService.getDayInfo(this.employeeID, timezone).subscribe(
          res => {
            const dialogRef = this.dialog.open(TimeCardDialogComponent, {
              minWidth: '90vw',
              height: '90vh',
              data : {
                jobs: jobs,
                day : res.Data,
                employeetype: this.employeetype,
                from: 'schedule',
                canEditTimes: false,
                who: this.usernamee
              }
            });
          }
        )
      })

  }

  openTripStatuses(job): void {

    // A failed history lookup must not keep the editable trip tasks from opening.
    forkJoin([
      this.scheduleService.getTripJobs(job.job_id),
      this.scheduleService.getPastTripTasks(job.job_id).pipe(catchError(() => of({ Error: true, Jobs: [] })))
    ]).subscribe(
      ([res, pastRes]: any[]) => {
        if(!res.Error){
          // Responsive dialog sizing
          const isMobile = window.matchMedia('(max-width: 540px)').matches;

          const dialogRef = this.dialog.open(TripStatusDialogComponent, {
            width: isMobile ? '100vw' : '90vw',
            maxWidth: isMobile ? '100vw' : '1000px',
            height: isMobile ? '100vh' : 'auto',
            maxHeight: isMobile ? '100vh' : '85vh',
            data : {
              jobs: res.Jobs.map(j =>{
                return {
                  job_id: j.job_id,
                  job_status: j.job_status ? j.job_status.trim() : '',
                  customer_jobtype: j.customer_jobtype,
                  customer_name: j.customer_name,
                }
              }),
              job: job,
              pastJobs: pastRes.Error ? [] : (pastRes.Jobs || [])
            },
            panelClass: ['custom-dialog-container', 'tsd-panel']
          });

          dialogRef.afterClosed().subscribe(result => {
            if (!result) { return; }  // Cancel

            const childJobs = result.jobs || [];
            const wantComplete = !!result.markComplete;
            const wasComplete = !!result.wasComplete;

            // 1. Persist every child job status (wait for all before reconciling).
            const saveObs = childJobs.length
              ? forkJoin(childJobs.map(j =>
                  this.scheduleService.setStatus(j.job_id, { job_status: j.job_status })))
              : of([]);

            saveObs.subscribe((results: any) => {
              (Array.isArray(results) ? results : []).forEach((r: any, i: number) => {
                if (r && r.Error) {
                  this.messager.openSnackBar('Error saving status for ' + childJobs[i].customer_jobtype + ': ' + r.Message, '', 'errorAlert');
                }
              });
              this.messager.openSnackBar('Trip statuses saved.', '', 'successAlert');

              // 2. Complete or reopen the parent trip based on the checkbox.
              let parentObs: Observable<any> = of(null);
              if (wantComplete && !wasComplete) {
                parentObs = this.scheduleService.setStatus(job.job_id, { job_status: 'Complete' }).pipe(
                  tap((r: any) => { if (!r.Error) { job.job_status = 'Complete'; } }));
              } else if (!wantComplete && wasComplete) {
                parentObs = this.scheduleService.setStatus(job.job_id, { job_status: 'Scheduled' }).pipe(
                  tap((r: any) => { if (!r.Error) { job.job_status = 'Scheduled'; } }));
              }

              parentObs.subscribe((r: any) => {
                if (r && r.Error) {
                  this.messager.openSnackBar('Error updating trip status: ' + r.Message, '', 'errorAlert');
                } else if (wantComplete && !wasComplete) {
                  this.messager.openSnackBar('Trip marked Complete.', '', 'successAlert');
                }

                // 3. Only when completing the trip, reconcile leftover jobs still Scheduled ->
                //    offer to move them to a future trip with a reason note. Failed jobs are
                //    deliberately left alone here — per Josh (Trello card comment, 2026-08-10),
                //    rescheduling failed jobs is a manual Scheduling Team process, not something
                //    this dialog should prompt for.
                if (wantComplete) {
                  this.promptTripReschedule(job, childJobs);
                }
              }, () => {
                this.messager.openSnackBar('Error updating trip status.', '', 'errorAlert');
              });
            }, () => {
              this.messager.openSnackBar('Error saving trip statuses.', '', 'errorAlert');
            });
          });

        }else {
          this.messager.openSnackBar('Error retrieving trip jobs: ' + res.Message, '', 'errorAlert');
        }
      }, err => {
        this.messager.openSnackBar('Error retrieving trip jobs: ' + err, '', 'errorAlert');
      }
    );

  }

  // Statuses that mean a child job is actually DONE (in some terminal sense) and should never
  // be offered up as "still incomplete" when a trip is marked Complete.
  private static readonly TRIP_TERMINAL_STATUSES = ['pass', 'complete', 'fail', 'fail-nr', 'fail-epo', 'fail-ris'];

  // (b) Any child job left in a non-terminal status (Scheduled, Projected, On hold, blank/never
  // touched, etc.) -> offer to move them to a future trip, capturing a required reason that is
  // appended to each moved job's job_notes as "<jobtype> moved to future trip <reason>".
  // Deliberately NOT a literal 'Scheduled' match: trip children are created as 'Projected' and
  // otherwise never get promoted, so a literal match let those silently slip through uncaptured.
  private promptTripReschedule(parentJob: any, allJobs: any[]): void {
    const incompleteJobs = (allJobs || []).filter(j =>
      !ScheduleComponent.TRIP_TERMINAL_STATUSES.includes((j.job_status || '').trim().toLowerCase())
    );
    if (incompleteJobs.length === 0) { return; }

    const jobtypeList = incompleteJobs.map(j => (j.customer_jobtype || '').toString().trim()).filter(Boolean).join(', ');
    const afterDate = String(parentJob.schedule_date).substring(0, 10);
    const locationId = parentJob.location_id || parentJob.LOCATION_ID;
    this.scheduleService.getFutureTrips(locationId, afterDate).subscribe(
      res => {
        if (res.Error || !res.Trips || res.Trips.length === 0) { return; }
        const rescheduleRef = this.dialog.open(TripRescheduleDialogComponent, {
          width: '480px',
          data: {
            futureTrips: res.Trips,
            count: incompleteJobs.length,
            title: 'Reassign Incomplete Jobs',
            description: incompleteJobs.length + ' job(s) were left incomplete: ' + jobtypeList + '.',
            requireReason: true
          }
        });
        rescheduleRef.afterClosed().subscribe((choice: any) => {
          if (!choice || !choice.tripId) { return; }
          const incompleteJobIds = incompleteJobs.map(j => j.job_id);
          this.locationService.updateTripJobs(incompleteJobIds, choice.tripId, choice.reason).subscribe(
            (res2: any) => {
              if (res2.Error) {
                this.messager.openSnackBar('Error reassigning jobs: ' + res2.Message, '', 'errorAlert');
              } else {
                this.messager.openSnackBar('Incomplete jobs reassigned to selected trip.', '', 'successAlert');
                this.logger.info(this.usernamee + ' moved task(s) ' + incompleteJobIds.join(', ') + ' from trip job_id: ' + parentJob.job_id
                  + ' to trip job_id: ' + choice.tripId + ' with location_id: ' + locationId);
              }
            },
            () => { this.messager.openSnackBar('Error reassigning jobs.', '', 'errorAlert'); }
          );
        });
      },
      () => { /* silent skip on network error */ }
    );
  }

  openFormByLocationFormID(location_id, form_id): void {

    let pics = {} as any;
    let notes = {};
    let formData = {} as any;
  }



  // The form resolution the Form button performs (onFormClickAll -> openDialogSequence), minus opening
  // the rater form dialog. Creates the form when the location has none, the same way handleNewForm does.
  async ensureFormId(job): Promise<number> {
    try{
      if(job.form_id){
        if(job.job_form_id == null){
          await this.scheduleService.setForm(job.job_id, {form_id: job.form_id}).toPromise();
          job.job_form_id = job.form_id;
        }
        return job.form_id;
      }
      const found: any = await this.scheduleService.getLocationFormID(job.location_id).toPromise();
      if(found && found.FormID > 0 && found.FormID != null){
        job.form_id = found.FormID;
        job.locpics_id = found.LocPicsID;
        await this.scheduleService.setForm(job.job_id, {form_id: found.FormID}).toPromise();
        await this.scheduleService.setFormLocmain(job.location_id, found.FormID).toPromise();
        job.job_form_id = found.FormID;
        return found.FormID;
      }
      const newform: any = await this.handleNewForm(job, job.job_id, job.location_id, job.schedule_date, {});
      if(!newform || !newform.form_id){ return 0; }
      job.form_id = newform.form_id;
      job.job_form_id = newform.form_id;
      job.locpics_id = newform.locpics_id;
      return newform.form_id;
    }catch(err){
      this.logger.error(this.usernamee + ' could not resolve a form id for job id-' + job.job_id
        + ' during the selfie prompt with location_id: ' + job.location_id + ' : ' + JSON.stringify(err));
      return 0;
    }
  }

  async openDialogSequence(jobData) {

    // ... initial setup ...

    let job_id = jobData.job_id;
    let location_id = jobData.location_id;
    let schedule_date = jobData.schedule_date;

    let fwidth, fheight;
    //media query see if it's full screen/ or mobile device.
    //if it's at least 500 px
    let mediaWidth = window.matchMedia('(min-width: 500px)');

    if (mediaWidth.matches) {
      //set the width manually
      fwidth = '575px;';
      fheight = '700px;';
    } else {
      fwidth = '100vw';
      fheight = '100vh';
    }

    let theData = {
        formData: {
          form_id: 0,
        },
        pics: {},
        notes: {},
        job_id: job_id,
        location_id: location_id,
        schedule_date : schedule_date,
        tags: jobData.tags,
        noSave : false
    };

    this.setDialogSize();

    let formID;
    let firsttrip = false;
    let picsID;
    let notesID;

    //do a deep search for the form_id

    //fast check to see if this location has a form_id
    if(jobData.form_id){
      //open existing form
      //make sure there is a pics id as well
      if(jobData.locpics_id == null){

        this.messager.openSnackBar('Searching for photo record...', '', 'successAlert');
        //check database for pics id entry. 
        this.scheduleService.searchPicsID(location_id).subscribe(
          async res => {
            if(res.Error){
              this.messager.openSnackBar('No photo record found creating new: ', '', 'errorAlert');
              const pics = await this.insertPicsOnly(job_id, location_id);
              jobData.locpics_id = pics.locpics_id;
              this.messager.openSnackBar('Opening form...', '', 'successAlert');
              picsID = pics.locpics_id;
              formID = jobData.form_id;
              this.openForm(picsID, formID, location_id, jobData, theData);
            }else {
              if(res.id != null && res.id != 0){

                this.messager.openSnackBar('Found...', '', 'successAlert');
                jobData.locpics_id = res.id;
                picsID = res.id;
                formID = jobData.form_id;
                this.scheduleService.setPicsLocmain(location_id, res.id).subscribe(
                  res => {
                    this.messager.openSnackBar('Found...Opening existing form...', '', 'successAlert');
                    this.openForm(picsID, formID, location_id, jobData, theData);
                  });
              }else {
                  this.messager.openSnackBar('No photo record found creating new: ', '', 'errorAlert');
                  const pics = await this.insertPicsOnly(job_id, location_id);
                  jobData.locpics_id = pics.locpics_id;
                  this.messager.openSnackBar('Creating new photo record...Opening form...', '', 'successAlert');
                  picsID = pics.locpics_id;
                  formID = jobData.form_id;
                  this.openForm(picsID, formID, location_id, jobData, theData);
              }
            }});

      }else {

        this.messager.openSnackBar('Opening existing form...', '', 'successAlert');
        formID = jobData.form_id;
        picsID = jobData.locpics_id;
        this.openForm(picsID, formID, location_id, jobData, theData); 
      
      }

    }else {
      //do a deep search for an existing form. 
      this.scheduleService.getLocationFormID(location_id).subscribe(async res => {
        if(res.FormID > 0 && res.FormID != null){
          jobData.form_id = res.FormID;
          jobData.locpics_id = res.LocPicsID;
          this.messager.openSnackBar('Form data changed...loading recent data...', '', 'successAlert');
    
          setTimeout(() => {
            this.messager.openSnackBar('Loaded, click form button again', '', 'successAlert');
          },2000);
        } else {
          const newform = await this.handleNewForm(jobData, job_id, location_id, schedule_date, theData);
          jobData.form_id = newform.form_id;
          jobData.job_form_id = newform;
          jobData.locpics_id = newform.locpics_id;
          formID = newform.form_id;
          firsttrip = newform.firsttrip;
          picsID = newform.locpics_id;
          this.openForm(picsID, formID, location_id, jobData, theData);
        }
      });
    }

}

comingsoon() {
  this.messager.openSnackBar('Coming Soon...', '', 'successAlert');
}


openForm(picsID, formID, location_id, jobData, theData) {  
  this.scheduleService.getRaterPicslocmainRF(picsID).subscribe(
    res => {
      theData.pics = res.Photos;
      theData.pics.id = parseInt(picsID);
      this.scheduleService.getDataByFormID(formID).subscribe(
        res => {
          let upd = res.formData || {};

          upd.plan_id = jobData.plan || 0;
          upd.note = jobData.note || 'No Job Notes';
          upd.loclog = jobData.loclog;
          upd.job_id = jobData.job_id;
          upd.jobinfo = jobData;
          upd.customer = jobData.customer;
          upd.tags = jobData.tags;

          theData.formData = upd;
          theData.formData.form_id = jobData.form_id;

          theData.formData = res.formData;
          this.scheduleService.getRaterNotes(location_id).subscribe(
            res => {
              if(res.Rows > 0){
                theData.notes = res.Notes[0];
              }
              let dialog = this.openRaterForm(theData);
              dialog.afterClosed().subscribe(result => {
              });
            }, err => {
              this.messager.openSnackBar('Error: ' + err.message, '', 'errorAlert');
            });

        });
    }, err =>{

    });

}

/*
async handleExistingFormLegacy(jobData, job_id, theData) {
  try {
      theData.pics = await this.loadPicsID(jobData.locpics_id);
      theData.formData = await this.loadFormID(jobData.form_id);
      theData.notes = await this.loadRaterNotes(jobData.location_id);
      this.openRaterForm(theData);
  } catch (error) {
      this.messager.openSnackBar('Error: ' + error.message, '', 'errorAlert');
  }
}
*/

async insertPicsOnly(job_id, location_id){

  let pics = await this.scheduleService.insertLocPics(location_id,job_id).toPromise();
  let picsid = pics.Data.id;
  const setPicsID = await this.scheduleService.setPicsLocmain(location_id, picsid).toPromise();
  return {locpics_id: picsid};

}


async handleNewForm(jobData, job_id, location_id, schedule_date, theData) {
  let firsttrip = false;
  try {
      let theform_id;
        let form = {
          location_id : location_id,
          job_id : job_id
        }
        
        firsttrip = true;
        const formID = await this.scheduleService.addNewRaterform(form).toPromise();
        theform_id = formID.formData.id;
        const setFormID = await this.scheduleService.setForm(job_id, {form_id: theform_id}).toPromise();
          const sfl = await this.scheduleService.setFormLocmain(location_id, theform_id).toPromise();

          let notes = await this.scheduleService.addRaterNotes(parseInt(location_id)).toPromise();
          let notesid = notes.Data.id;
          let pics = await this.scheduleService.insertLocPics(location_id,job_id).toPromise();
          let picsid = pics.Data.id;
          const setPicsID = await this.scheduleService.setPicsLocmain(location_id, picsid).toPromise();
          
          this.messager.openSnackBar('First trip...blank form loaded','','successAlert');
          return {form_id: theform_id, firsttrip: firsttrip, locpics_id: picsid, notes_id: notesid};


  } catch (error) {
    ////console.log(error);
    this.messager.openSnackBar('Error creating blank form','','errorAlert');
    return {form_id: 0, firsttrip: true};
    /* this.messager.openSnackBar('Error: ' + error.message, '', 'errorAlert');
    return {form_id: 0, firsttrip: true}; */

  }

}

async loadLastJob(location_id, date) {
  try {
    //get last job
    const lastJobResponse: any = await this.scheduleService.getLastJob(location_id, date).toPromise();
    return lastJobResponse;
  } catch (error) {
    console.error('Error loading last job:', error);
    this.messager.openSnackBar('Could not load last job: ' + error.message, '', 'errorAlert');
    return {};
  }
}

// Example of a modular function for loading pics
/*
async loadPics(job_id) {
  // Convert Observable to Promise and use await
  // Handle any logic related to loading pictures
}
*/

async loadPicsID(locpics_id){
  try {
    const picsOneResponse: any = await this.scheduleService.getRaterPicslocmainRF(locpics_id).toPromise();
    return picsOneResponse.Photos;
  } catch (error) {
    console.error('Error loading pictures:', error);
    this.messager.openSnackBar('Could not load pictures: ' + error.message, '', 'errorAlert');
  }
}

async loadFormID(form_id){
  try {
    const formDataResponse: any = await this.scheduleService.getDataByFormID(form_id).toPromise();
    return formDataResponse.formData;
  } catch (error) {
    console.error('Error loading form:', error);
    this.messager.openSnackBar('Could not load form: ' + error.message, '', 'errorAlert');
  }
}

async loadPics(lastJobID, job_id, theData) {
  try {

      // Get Rater Pics One
      //get picture from the last job id.
      const picsOneResponse: any = await this.scheduleService.getRaterPicsOne(lastJobID).toPromise();
      theData.pics[0] = picsOneResponse.Photos;

      if(picsOneResponse.photos.length > 0){

        //set locpics to the id of this photo record.
        //create API/service call here

      } else {
        //if there are no photos returned, add a new row.

        const picsAddResponse = await this.scheduleService.getRaterPicsAdd(job_id).toPromise();
        ////console.log(picsAddResponse);
        //set value of locpics to the id of the new photo record.
      }

      this.messager.openSnackBar('Pictures loaded!', '', 'successAlert');
  } catch (error) {
      console.error('Error loading pictures:', error);
      this.messager.openSnackBar('Could not load pictures: ' + error.message, '', 'errorAlert');
  }
}

/*
async loadFormData(job_id) {
  // Convert Observable to Promise and use await
  // Handle any logic related to loading pictures
}
*/


async loadRaterNotes(job_id) {
  // Convert Observable to Promise and use await
  // Handle any logic related to loading pictures
}



// Similar functions for loadFormData, loadRaterNotes, etc.

setDialogSize() {
  // Logic to set dialog size
}

openRaterForm(theData) {
  // Logic to open the Rater form dialog

  return this.dialog.open(RaterformComponent, {
    minWidth: '100vw',
    height: '100vh',
    data: theData,
    panelClass : 'custom-dialog-container',
    autoFocus : false
  });

}





/*
  openDialogSequence(jobData, job_id, location_id,schedule_date?): void {

    jobData.job_id = job_id;
    jobData.location_id = location_id;
    //jobData.form_id = 100211;

    let pics = {} as any;
    let notes = {};
    let formData = {} as any;

    let mod = {} as any;
    let deepFormId = 0;

    let theData = {
      formData: formData,
      pics: pics,
      notes: notes,
      job_id: job_id,
      location_id: location_id,
      schedule_date : schedule_date,
      tags: jobData.tags
    }

    let fwidth, fheight;
    //see if this job has a form already. If so, open it.

    // 1. Does this job have a form associated with it? Case: someone is coming back to this page to edit it again

    //media query see if it's full screen/ or mobile device.

    //if it's at least 500 px
    let mediaWidth = window.matchMedia('(min-width: 500px)');

    if (mediaWidth.matches) {
      //set the width manually
      fwidth = '575px;';
      fheight = '700px;';
    } else {
      fwidth = '100vw';
      fheight = '100vh';
    }


    // 2.A If we have an id, we've worked on a form for this job, so just pull that data using the id associated with the job.
    if (jobData.form_id) {
      this.scheduleService.getRaterPicsAll(job_id).subscribe(
        (res) => {
          // ************************************
          theData.pics = res.Photos;
          // ************************************
          this.scheduleService.getDataByFormID(jobData.form_id).subscribe(
            (res) => {
              //formData = res.formData;
              this.messager.openSnackBar('Loading form... ', '', 'successAlert');

              // ************************************
              //theData.formData = res.formData;
              // ************************************

              let upd = res.formData;
              upd.plan_id = jobData.plan || 0;
              upd.note = jobData.note || 'No Job Notes';
              upd.loclog = jobData.loclog;
              upd.job_id = jobData.job_id;
              upd.jobinfo = jobData;
              upd.customer = jobData.customer;
              upd.tags = jobData.tags;

              theData.formData = upd;
              theData.formData.form_id = jobData.form_id;

              this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                res => {
                  if (res.Rows > 0) {
                    theData.notes = res.Notes[0];

                        //var element = document.getElementById("schedList");
                        //element.classList.add("removeItems");

                    let dialogRef = this.dialog.open(RaterformComponent, {
                      minWidth: '100vw',
                      height: '100vh',
                      data: theData,
                      panelClass : 'custom-dialog-container',
                      autoFocus : false
                    });
                  } else {
                    this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                      res => {
                        theData.notes = {};
                        let dialogRef = this.dialog.open(RaterformComponent, {
                          minWidth: '100vw',
                          height: '100vh',
                          data: theData,
                          panelClass: 'custom-dialog-container',
                          autoFocus : false
                        });

                      }, err => {
                      });
                  }
                }, err => {
                });
              //open form here:
            }, err => {
              this.messager.openSnackBar('Could not load form: ' + err.message, '', 'errorAlert');
            });

        }, err => {
          this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
        });


    }


    else {

      this.messager.openSnackBar('No id.', '', 'errorAlert');
      // 2.B We need assess whether or not we've been to this location, and if there are previous jobs.
      this.scheduleService.getLastJob(jobData.location_id, jobData.schedule_date).subscribe(
        (res) => {
          // if there's more than one row, we've done work there:
          if (res.Rows > 0) {
            // the last job will be the first in the array returned.
            let lastJobID = res.Jobs[0].job_id;


            //**handling pics*********************

            this.scheduleService.getRaterPicsOne(lastJobID).subscribe(
              (res) => {

                // ************************************
                theData.pics[0] = res.Photos;
                // ************************************
                this.scheduleService.getRaterPicsAdd(job_id).subscribe(
                  (res) => {
                    this.scheduleService.getRaterPicsAddOnly(job_id, theData.pics[0]).subscribe(
                      (res) => {
                        this.messager.openSnackBar('Pictures loaded!', '', 'successAlert');
                        this.scheduleService.getFormByJob(lastJobID).subscribe(
                          (res) => {

                            if (res.Rows > 0) {
                              // ************************************
                              mod = res.FormData;
                              // ************************************

                              mod.job_id = job_id;
                              mod.location_id = location_id;
                              mod.jobinfo = jobData;

                              let oldFormId = mod.id;



                              this.scheduleService.addNewRaterform(mod).subscribe(
                                (res) => {
                                  mod.id = res.formData.id;
                                  let formID = res.formData.id;
                                  mod.note = jobData.note || '(No job notes)';

                                  let formObj = {
                                    form_id: res.formData.id
                                  }


                                  theData.formData = mod;
                                  theData.formData.form_id = res.formData.id;

                                  this.scheduleService.setForm(job_id, formObj).subscribe(
                                    (res) => {
                                      //open form from here
                                      jobData.form_id = formID;


                                      this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                                        res => {
                                          if (res.Rows > 0) {
                                            theData.notes = res.Notes[0];

                                                //var element = document.getElementById("schedList");
                                                //element.classList.add("removeItems");

                                            let dialogRef = this.dialog.open(RaterformComponent, {
                                              minWidth: '100vw',
                                              height: '100vh',
                                              data: theData,
                                              panelClass: 'custom-dialog-container',
                                              autoFocus : false
                                            });



                                          } else {
                                            this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                                              res => {
                                                theData.notes = {};
                                                    //var element = document.getElementById("schedList");
                                                    //element.classList.add("removeItems");

                                                let dialogRef = this.dialog.open(RaterformComponent, {
                                                  minWidth: '100vw',
                                                  height: '100vh',
                                                  data: theData,
                                                  panelClass: 'custom-dialog-container',
                                                  autoFocus : false

                                                });
/*
                                                dialogRef.afterClosed().subscribe(result => {
                                                //  element.classList.remove("removeItems");
                                                dialogRef = null;
                                                });

                                              }, err => {
                                              });

                                          }


                                        }, err => {
                                        });

                                      this.messager.openSnackBar('Opening form...', '', 'successAlert');

                                    }, err => {

                                    });

                                }, err => {
                                }
                              );

                            } else {

                              mod.location_id = location_id;
                              mod.job_id = job_id;

                              this.scheduleService.addNewRaterform(mod).subscribe(
                                (res) => {
                                  mod.form_id = res.formData.id;
                                  this.scheduleService.setForm(job_id, mod).subscribe(
                                    (res) => {
                                      jobData.form_id = mod.form_id;

                                      this.scheduleService.getDataByFormID(mod.form_id).subscribe(
                                        (res) => {
                                          let upd = mod;
                                          this.messager.openSnackBar('UPD copied... ', '', 'successAlert');
                                          upd.plan_id = jobData.plan;
                                          upd.taxparcel = jobData.taxparcel;
                                          upd.location_id = jobData.location_id;
                                          upd.loclog = jobData.loclog;
                                          upd.job_id = jobData.job_id;
                                          upd.jobinfo = jobData;
                                          upd.customer = jobData.customer;
                                          upd.note = jobData.note || "No job notes";
                                          upd.tags = jobData.tags;

                                          //open modal here.

                                          theData.formData = upd;
                                          theData.formData.form_id = jobData.form_id;


                                          this.scheduleService.getRaterNotes(jobData.location_id).subscribe(
                                            res => {
                                              if (res.Rows > 0) {
                                                theData.notes = res.Notes[0];
                                                  //  var element = document.getElementById("schedList");
    //element.classList.add("removeItems");

                                                let dialogRef = this.dialog.open(RaterformComponent, {
                                                  minWidth: '100vw',
                                                  height: '100vh',
                                                  data: theData,
                                                  panelClass: 'custom-dialog-container',
                                                  autoFocus : false

                                                });




                                              } else {
                                                this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                                                  res => {
                                                    theData.notes = {};
                                                        //var element = document.getElementById("schedList");
                                                        //element.classList.add("removeItems");

                                                    let dialogRef = this.dialog.open(RaterformComponent, {
                                                      minWidth: '100vw',
                                                      height: '100vh',
                                                      data: theData,
                                                      panelClass: 'custom-dialog-container',
                                                      autoFocus : false

                                                    });

                                                  }, err => {
                                                  });

                                              }


                                            }, err => {
                                            });


                                        }, err => {
                                          this.messager.openSnackBar('Error: ' + err, '', 'errorAlert');
                                        })
                                    }, err => {
                                      this.messager.openSnackBar('Error: ' + err, '', 'errorAlert');
                                    });

                                }, err => {
                                  this.messager.openSnackBar('Error: ' + err, '', 'errorAlert');
                                });

                            }

                          }, err => {
                            this.messager.openSnackBar('Error: ' + err, '', 'errorAlert');
                          }

                        ); //getFormByJob

                      }, err => {
                        this.messager.openSnackBar('Could not save picture profile: ' + err.message, '', 'errorAlert');
                      }
                    );
                  }, err => {
                    this.messager.openSnackBar('Could not create picture record: ' + err.message, '', 'errorAlert');
                  }
                );

              }, err => {
                this.messager.openSnackBar('Could not load pics: ' + err.message, '', 'errorAlert');
              }
            ); // getRaterPicsOne

            //**done handling pics****************

          } else {

            //it's our first time, add a row
            mod.job_id = job_id;
            mod.location_id = location_id;
            mod.jobinfo = jobData;

            this.scheduleService.getRaterPicsAdd(job_id).subscribe(
              (res) => {


                this.scheduleService.getRaterPicsAll(job_id).subscribe(
                  (res) => {
                    theData.pics = res.Photos;


                    //handle form
                    this.scheduleService.addNewRaterform(mod).subscribe(
                      (res) => {
                        let formID = res.formData.id;
                        mod.form_id = formID;
                        this.scheduleService.setForm(job_id, mod).subscribe(
                          (res) => {
                            jobData.form_id = formID;
                            this.scheduleService.getDataByFormID(formID).subscribe(
                              (res) => {
                                let upd = res.formData;
                                upd.plan_id = jobData.plan;
                                upd.loclog = jobData.loclog;
                                upd.note = jobData.note || 'No plan notes';
                                upd.job_id = jobData.job_id;
                                upd.jobinfo = jobData;
                                upd.customer = jobData.customer;
                                upd.tags = jobData.tags;

                                this.scheduleService.addRaterNotes(jobData.location_id).subscribe(
                                  res => {
                                    theData.notes = {}
                                  }, err => {
                                  });

                                theData.formData = upd;
                                theData.formData.form_id = jobData.form_id;

                                    //var element = document.getElementById("schedList");
                                    //element.classList.add("removeItems");

                                const dialogRef = this.dialog.open(RaterformComponent, {
                                  minWidth: '100vw',
                                  height: '100vh',
                                  data: theData,
                                  panelClass: 'custom-dialog-container',
                                  autoFocus : false

                                });

                              }, err => {
                                this.messager.openSnackBar('Error loading pics: ', '', 'errorAlert');

                              });

                          }, err => {
                            this.messager.openSnackBar('Error loading pics: ', '', 'errorAlert');

                          });

                      }, err => {
                        this.messager.openSnackBar('Error loading pics: ', '', 'errorAlert');

                      });


                  }, err => {
                    this.messager.openSnackBar('Error loading pics: ', '', 'errorAlert');
                  }
                );


                this.messager.openSnackBar('Ready for pics.', '', 'successAlert');



              }, err => {
                this.messager.openSnackBar('Error loading pics: ', '', 'errorAlert');
              }
            )



          } //end else
        }, err => {
        }); // getLastJob

    }//end else


  }//end openDialogSequence function
*/

  clearTheDiv() {
    //var element = document.getElementById("schedList");
    //element.classList.add("removeItems");

    // add old jobs to oldFiltered jobs
  }

  blurTheSearch() {
    var element = document.getElementById("schedList");
    element.classList.remove("removeItems");
  }

  openDialog(jobData, job_id, location_id, form_id): void {

    jobData.job_id = job_id;
    jobData.location_id = location_id;
    let pics = {};
    let notes = {};
    let formData = {};
    jobData.form_id = form_id;
    jobData.usernamee = this.usernamee;
    //see if this job has a form already. If so, open it.



    // check if specific job has a form already
    //

    //query jobs table to see if there is more than one job for this location
    this.scheduleService.getJobsByLocation(location_id).subscribe(
      (res) => {
        if (res.Rows > 0) {
          jobData.Jobs = res.Jobs;

          const dialogRef = this.dialog.open(RaterformSelectorComponent, {
            minWidth: '40vw',
            height: '80vh',
            data: jobData
          });

          dialogRef.afterClosed().subscribe(result => {
            //get pics, store in object
            if(result){
              ////console.log(result);

              jobData.form_id = result.form_id;
              jobData.locpics_id = result.locpics_id;

              ////console.log(jobData);

              if(result.clear){
                this.logger.info(this.usernamee + ' successfully cleared form  at ' + jobData.street_address + '- ' + jobData.subdivision_name + ' - ' + jobData.lot + ' ');
              }else {
                this.logger.info(this.usernamee + ' successfully loaded form with id: '+ result.form_id + ' at ' + jobData.street_address + '- ' + jobData.subdivision_name + ' - ' + jobData.lot + ' ');
              }

              this.cdr.detectChanges();
            }else {
              //do nothing
            }
          })
        } else { // not more than one row, automatically open new row
          this.messager.openSnackBar('No old jobs for this home, click form button.', '', 'successAlert');
        }
      }, err => {
        this.messager.openSnackBar('Error: ' + err.message, '', 'errorAlert');

      });


  }

subdivisionPopup(job) {

    this.subService.getOneSubdivision(job.subdivision).subscribe(
      (res) => {

        let thisSub = {
          mode: 3,
          subdivision_id: res.Subdivision.subdivision_id,
          subdivision_name: res.Subdivision.subdivision_name,
          consultant : res.Subdivision.consultant, 
          city: res.Subdivision.city,
          state: res.Subdivision.state,
          cz: res.Subdivision.cz,
          gps: res.Subdivision.gps,
          inactivesubdivision: res.Subdivision.inactivesubdivision,
          dzip: res.Subdivision.dzip,
          lat: res.Subdivision.lat,
          lng: res.Subdivision.lng,
          dhvaccontractor: res.Subdivision.dhvaccontractor,
          region: res.Subdivision.region,
          ratercompid: res.Subdivision.ratercompid,
          jurisdictionid: res.Subdivision.jurisdictionid,
          weatherloc: res.Subdivision.weatherloc,
          scope: res.Subdivision.scope,
          elevation: res.Subdivision.elevation,
          priceadder: res.Subdivision.priceadderk,
          municipality: res.Subdivision.municipality,
          areamanager: res.Subdivision.areamanager,
          areamanemail: res.Subdivision.areamanemail,
          archive: res.Subdivision.archive,
          gasutility: res.Subdivision.gasutility,
          elecutility: res.Subdivision.elecutility,
          loggedIn: this.usernamee
        }
       
       
       this.modalSub = thisSub;

       if(thisSub.consultant > 0){
        this.employeeService.getOneEmployee(thisSub.consultant).subscribe(
          res => {
            this.modalSub = {
              ...thisSub,
              consultant_name : res.employee_name.trim(),
              consultant_email : res.e_mail.trim(),
              consultant_phone : res.phone.trim()

            }
            this.openSubDivModal(this.modalSub);
          })

       }else{
            this.openSubDivModal(this.modalSub);
       }

     }, err => {
        this.messager.openSnackBar('Error getting subdivision info (possibly no subdivision).', '', 'errorAlert');
      });

    //alert('Popup');
  }

  clockIn() {
    this.messager.openSnackBar('Clock in function_09/10/21', '', 'successAlert');
  }

  updateStartTime(job) {


    //document.getElementById('clockinbutton').setAttribute('style', 'display:none');
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


    this.scheduleService.updateStartTime(job, this.employeeID, timezone).subscribe(
      res => {
        job.clockedin = true;
        job.starttime = res.Date;
        this.messager.openSnackBar('Clocked In', '', 'successAlert');
        this.logger.info(this.usernamee + ' clocked into  ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);

        this.scheduleService.updateFrontPage().subscribe(
          res => {
          }, err => {
          })
      },
      err => {
        this.logger.error(this.usernamee + ' tried clocking into ' + job.job_id + ' Error: ' + err);
        this.messager.openSnackBar('Could not clock in: ' + err, '', 'errorAlert');
      }
    );

  }

  /*
  calculateTime(job){
    let today = new Date();
    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    let dateTime = date + ' '+time;
    return dateTime - job.starttime;
  }
*/


  updateEndTime(job) {
    job.clockedin = !job.clockedin;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


    this.scheduleService.updateEndTime(job,this.employeeID, timezone).subscribe(
      res => {
        this.logger.info(this.usernamee + ' clocked into ' + job.street_address + '- ' + job.subdivision_name + ' - ' + job.lot + ' with job_id: ' + job.job_id);

        this.messager.openSnackBar('Clocked Out! Time on job: ' + (typeof res.Total.hours === 'undefined' ? '' : res.Total.hours + ' hour(s) ') + (typeof res.Total.minutes === 'undefined' ? '' : (res.Total.minutes + " min")) + " " + res.Total.seconds + " sec", '', 'successAlert');
        this.scheduleService.updateFrontPage().subscribe(
          res => {
          }, err => {
          })

      },
      err => {
        this.logger.error(this.usernamee + ' tried clocking into ' + job.job_id + ' Error: ' + err);
        this.messager.openSnackBar('Could not clock out: ' + err, '', 'errorAlert');
      }
    );

  }

  dateAsString(date: Date): string {

    const dated = new Date(date);
    const dd = dated.getDate();
    const mm = dated.getMonth() + 1;

    // tslint:disable-next-line: indent
    const yyyy = dated.getFullYear();
    // tslint:disable-next-line: radix
    const day = dd < 10 ? '0' + dd : dd;
    const month = mm < 10 ? '0' + mm : mm;

    const formattedDate = month + '-' + day + '-' + yyyy;

    return formattedDate;

  }




  toggleLinkData(index: any) {
    this.toggleLink = !this.toggleLink;
    this.toggleItem[index] = !this.toggleItem[index];
  }

  // "On our way" text: opens the rater's own SMS app with a pre-filled message. RH sends nothing.
  canShowOnOurWay(job): boolean {
    return !!job && job.oow_allowed === true && job.flex_start_date == null &&
      typeof job.conf_status === 'string' && job.conf_status.trim().toLowerCase() === 'builder confirmed' &&
      OOW_REGIONS.includes(String(job.region || '').trim().toUpperCase());
  }

  isOowPressed(job): boolean {
    return !!job && !!this.oowPressedStatus[job.job_id];
  }

  buildOnOurWayMessage(job): string {
    const t = (v) => (typeof v === 'string' ? v.trim() : '');
    const firstName = (t(job.name) || t(job.contact_name)).split(/\s+/)[0];
    const rater = t(job.employee_name) || t(this.auth.getEmployeeName());
    const where = [t(job.subdivision_name), t(job.lot) ? 'Lot ' + t(job.lot) : ''].filter(Boolean).join(' ');
    const address = t(job.street_address);
    const jobType = t(job.job_alias) || t(job.customer_jobtype);
    const optOut = t(job.oow_optout_url);
    return 'Hi' + (firstName ? ' ' + firstName : '') + ', this is ' + (rater || 'your inspector') +
      " with Performance Point. I'm on my way" + (where ? ' to ' + where : '') +
      (address ? ' (' + address + ')' : '') + (jobType ? ' for the ' + jobType : '') + '.' +
      (optOut ? ' Stop these texts: ' + optOut : '');
  }

  onOurWay(job): void {
    let digits = String(job.contact_phone || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') { digits = digits.substring(1); }
    if (digits.length !== 10) {
      this.messager.openSnackBar('No valid builder phone on this job', '', 'errorAlert');
      return;
    }
    const message = this.buildOnOurWayMessage(job);
    this.logger.info(this.auth.getEmployeeName() + ' opened on-our-way text for job ' + job.job_id);
    this.oowPressedStatus[job.job_id] = true;
    job.oow_pressed = true;
    this.recordOnOurWayPress(job, message);
    // ?&body= is accepted by both iOS and Android; window.open is blocked or blank on mobile.
    window.location.href = 'sms:+1' + digits + '?&body=' + encodeURIComponent(message);
  }

  // YYYY-MM-DD for a Date or an ISO/YYYY-MM-DD string; '' otherwise.
  ymdOf(v): string {
    if (v instanceof Date && !isNaN(v.getTime())) {
      const p = (n: number) => (n < 10 ? '0' : '') + n;
      return v.getFullYear() + '-' + p(v.getMonth() + 1) + '-' + p(v.getDate());
    }
    return typeof v === 'string' ? v.substring(0, 10) : '';
  }

  // Audit row for the On Our Way log report. Fire-and-forget: the SMS hand-off never waits on it.
  recordOnOurWayPress(job, message: string): void {
    const t = (v) => (typeof v === 'string' ? v.trim() : (v === null || v === undefined ? '' : String(v)));
    let tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { tz = ''; }
    const press = {
      employee_id: this.employeeID || this.auth.getEmployeeId(),
      employee_name: t(this.auth.getEmployeeName()),
      pressed_tz: tz,
      job_id: job.job_id,
      location_id: job.location_id,
      contact_id: job.oow_contact_id,
      contact_name: t(job.name) || t(job.contact_name),
      contact_phone: t(job.contact_phone),
      street_address: t(job.street_address),
      subdivision_name: t(job.subdivision_name),
      lot: t(job.lot),
      job_type: t(job.job_alias) || t(job.customer_jobtype),
      customer_job: job.customer_job,
      schedule_date: this.ymdOf(job.schedule_date),
      message: message
    };
    this.oowLog.logPress(press).subscribe(
      (res: any) => { if (res && res.Error) { this.logger.error('On-our-way press not logged for job ' + job.job_id + ': ' + res.Message); } },
      err => { this.logger.error('On-our-way press not logged for job ' + job.job_id + ': ' + (err && err.message ? err.message : err)); }
    );
  }

  additionalWork(job) { 
    this.breakpointobserver.observe([Breakpoints.Handset]).subscribe(result => {

      const dialogConfig = {
        data: {
          location_id: job.location_id,
          job_id: job.job_id,
          loadPrevious : true
        },
        width: result.matches ? '95vw' : '500px',
        height: result.matches ? '95vh' : '80vh',
        panelClass: 'custom-dialog-container'
      }

      const dialogRef = this.dialog.open(AdditionalworkComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
          if (result === 1) {
            this.logger.info(this.usernamee + ' added additional work to job: ' + job.job_id + ' THINGS: [' + result + ']');
            this.messager.openSnackBar('Additional work added!', '', 'successAlert');
          }else {
            //this.messager.openSnackBar('.', '', 'errorAlert');
          }
        });
    });
  }

}

@Component({
  selector: 'app-draincam',
  templateUrl: './draincam.component.html',
  styleUrls: ['./schedule.component.css']
})
export class DrainCamComponent implements OnInit {

  camData: any;
  constructor( public dialogRef: MatDialogRef<RatingPhotosDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ScheduleJob, public scheduleService: ScheduleService, private messager: MessagerComponent) { }

  ngOnInit(): void {
    this.camData = this.data.data;


  }

}

@Component({
  selector: 'app-safetyinsp',
  templateUrl: './safetyinspection.component.html',
  styleUrls: ['./schedule.component.css']
})
export class SafetyInspectionComponent implements OnInit {


  incidents: any;


  constructor(public dialogRef: MatDialogRef<RatingPhotosDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public scheduleService: ScheduleService, private messager: MessagerComponent) { }


  ngOnInit(): void {
    this.incidents = this.data.data.SafetySubform_Subform;
  }

}

@Component({
  selector: 'app-thermal-dialog',
  template: `
    <div style="display: flex;
    justify-content: center;">
      <h1 mat-dialog-title style="text-align:center;">Thermal Required?</h1>
    </div>
    <div style="display: flex;
    justify-content: center;">
      <button mat-button (click)="dialogRef.close(1)"  style="border: 0;
    height: 40px;
    width: 100px;
    margin: 10px;">Yes</button>
      <button mat-button (click)="dialogRef.close(2)"  style="background: #ffffffaf;
    border: 0;
    height: 40px;
    margin: 10px;
    width: 100px;">No</button>
    </div>
  `,
  styleUrls: ['./schedule.component.css']
})
export class ThermalDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<ThermalDialogComponent>) { }

    ngOnInit(): void {
    }

  }


interface Job {
  job_id: number;
  job_status: string;
  customer_jobtype: string;
  customer_name: string;
}
@Component({
  selector: 'app-trip-status-dialog',
  template: `

    <h2 mat-dialog-title class="tsd-title" style="font-size: 2em;
    padding-left: 0 !important;">
    Trip Tasks
    </h2>

    <div mat-dialog-content class="tsd-content">
      <div *ngIf="data?.job" class="tsd-trip-header">
        <div class="tsd-trip-header-info">
          <strong>Trip Status:</strong>
          <span class="tsd-trip-status-text" [class.tsd-trip-status-complete]="markComplete">
            {{ markComplete ? 'Complete' : (tripStatus() || 'Unknown') }}
          </span>
        </div>
        <mat-checkbox class="tsd-complete-check" [(ngModel)]="markComplete" color="primary">
          Mark this trip complete
        </mat-checkbox>
      </div>

      <div class="tsd-header-row">
        <div class="tsd-col tsd-customer">Customer</div>
        <div class="tsd-col tsd-jobtype">Job Type</div>
        <div class="tsd-col tsd-status">Status</div>
      </div>

      <div class="tsd-row" [class.tsd-row-active]="isJobActioned(job)" *ngFor="let job of data.jobs">
        <div class="tsd-col tsd-customer">
          <span class="tsd-mobile-label">Customer:</span>
          <span class="tsd-mobile-value">{{ job.customer_name }}</span>
        </div>
        <div class="tsd-col tsd-jobtype">
          <span class="tsd-mobile-label">Job Type:</span>
          <span class="tsd-mobile-value">{{ job.customer_jobtype }}</span>
        </div>

        <div class="tsd-col tsd-status">
          <span class="tsd-mobile-label">Status:</span>
          <mat-form-field appearance="outline" class="tsd-status-field">
            <mat-select [(ngModel)]="job.job_status">
              <mat-option *ngFor="let s of statusOptions" [value]="s.value">
                {{ s.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="tsd-empty" *ngIf="!data?.jobs?.length">
        No jobs found.
      </div>

      <ng-container *ngIf="data?.pastJobs?.length">
        <h3 class="tsd-past-title">Previous Tasks at this Location (read-only)</h3>

        <div class="tsd-header-row">
          <div class="tsd-col tsd-customer">Customer</div>
          <div class="tsd-col tsd-jobtype">Job Type</div>
          <div class="tsd-col tsd-past-date">Trip Date</div>
          <div class="tsd-col tsd-past-status">Status</div>
        </div>

        <div class="tsd-row tsd-row-past" *ngFor="let past of data.pastJobs">
          <div class="tsd-col tsd-customer">
            <span class="tsd-mobile-label">Customer:</span>
            <span class="tsd-mobile-value">{{ past.customer_name }}</span>
          </div>
          <div class="tsd-col tsd-jobtype">
            <span class="tsd-mobile-label">Job Type:</span>
            <span class="tsd-mobile-value">{{ past.customer_jobtype }}</span>
          </div>
          <div class="tsd-col tsd-past-date">
            <span class="tsd-mobile-label">Trip Date:</span>
            <span class="tsd-mobile-value">{{ past.trip_date | date:'M/d/yyyy' }}</span>
          </div>
          <div class="tsd-col tsd-past-status">
            <span class="tsd-mobile-label">Status:</span>
            <span class="tsd-mobile-value">{{ past.job_status || 'No status' }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div mat-dialog-actions align="end" class="tsd-actions">
      <button style="width:8em;" mat-stroked-button (click)="dialogRef.close(null)">Cancel</button>
      <button style="width:8em;" mat-flat-button color="primary" (click)="save()">Save</button>
    </div>


  `,
  styleUrls: ['./schedule.component.css']
})
export class TripStatusDialogComponent implements OnInit {

  statusOptions = [
    { value: 'Complete', viewValue: 'Complete' },
    { value: 'EPO hold', viewValue: 'EPO hold' },
    { value: 'Fail', viewValue: 'Fail' },
    { value: 'Fail-NR', viewValue: 'Fail-No Reschedule' },
    { value: 'On hold', viewValue: 'On hold' },
    { value: 'Pass', viewValue: 'Pass' },
    { value: 'Scheduled', viewValue: 'Scheduled' },
    { value: 'UnderRev', viewValue: 'Under Review' },
    { value: 'Canceled', viewValue: 'Canceled' },
  ];

    // Whether the parent trip should be marked complete on Save. Pre-checked when it already is.
    markComplete = false;
    // Snapshot of the parent's completion state when the dialog opened, so Save can detect reopen.
    private wasComplete = false;

    constructor(public dialogRef: MatDialogRef<TripStatusDialogComponent>,
      public dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: { jobs: Job[], job?: any, pastJobs?: any[] } ) { }

    ngOnInit(): void {
      this.wasComplete = this.isTripComplete();
      this.markComplete = this.wasComplete;
    }

    tripStatus(): string {
      const status = this.data?.job?.job_status;
      return status ? status.toString().trim() : '';
    }

    isTripComplete(): boolean {
      return this.tripStatus() === 'Complete';
    }

    save(): void {
      // Confirm only for the "forgot to check the box" case: trip wasn't already complete and
      // the box is still unchecked. If wasComplete is true and the user deliberately unchecked
      // it (to reopen the trip), that's an intentional action — don't second-guess it here.
      if (!this.markComplete && !this.wasComplete) {
        const confirmRef = this.dialog.open(WarningPopupComponent, {
          width: '380px',
          data: {
            warning_title: 'Mark Trip Complete?',
            warning_description: '',
            warning_sub: '',
            confirmText: 'Yes',
            cancelText: 'No',
            showCancelButton: true
          }
        });
        confirmRef.afterClosed().subscribe((result) => {
          // WarningPopupComponent closes with 2 for the confirm ("Yes") button, 1 for cancel
          // ("No"); anything else (backdrop/escape dismiss) is treated as "No" too — only an
          // explicit Yes should mark the trip complete.
          if (result === 2) {
            this.markComplete = true;
          }
          this.finishSave();
        });
      } else {
        this.finishSave();
      }
    }

    private finishSave(): void {
      this.dialogRef.close({
        jobs: this.data.jobs,
        markComplete: this.markComplete,
        wasComplete: this.wasComplete
      });
    }

    isJobActioned(job: Job): boolean {
      const s = job?.job_status ? job.job_status.toString().trim() : '';
      return s.length > 0 && s !== 'Scheduled';
    }

  }

@Component({
  selector: 'app-trip-reschedule-dialog',
  template: `
    <h2 mat-dialog-title style="font-size:1.4em;">{{ data.title }}</h2>
    <div mat-dialog-content>
      <p style="margin-bottom:16px;">
        {{ data.description }}
        Select a future trip to move them to:
      </p>
      <mat-radio-group [(ngModel)]="selectedTripId" style="display:flex;flex-direction:column;gap:10px;">
        <mat-radio-button *ngFor="let trip of data.futureTrips" [value]="trip.job_id"
          style="display:flex;align-items:center;">
          <span style="font-weight:500;min-width:100px;">{{ trip.schedule_date | date:'MMM d, y' }}</span>
          <span style="margin:0 8px;">—</span>
          <span style="flex:1;">{{ trip.customer_jobtype }}</span>
          <span style="margin-left:8px;font-size:0.85em;color:#666;">({{ trip.job_status }})</span>
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field *ngIf="data.requireReason" appearance="outline" style="width:100%;margin-top:16px;">
        <mat-label>Reason</mat-label>
        <textarea matInput [(ngModel)]="reason" rows="2"
          placeholder="Why are these jobs being moved to a future trip?"></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end" style="gap:8px;">
      <button mat-stroked-button (click)="dialogRef.close(null)">Skip</button>
      <button mat-flat-button color="primary"
        [disabled]="!selectedTripId || (data.requireReason && !reason.trim())"
        (click)="dialogRef.close({ tripId: selectedTripId, reason: reason.trim() })">Reassign</button>
    </div>
  `,
  styleUrls: ['./schedule.component.css']
})
export class TripRescheduleDialogComponent {
  selectedTripId: number | null = null;
  reason = '';

  constructor(
    public dialogRef: MatDialogRef<TripRescheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { futureTrips: any[], count: number, title: string, description: string, requireReason: boolean }
  ) {}
}


